// AUTO-GENERATED FILE - do not edit manually
// Generated by scripts/generate_products.py
// Aligned on the original Hyper OR I site content (r1ax45yuy3k0-d.space-z.ai)
// 12 boutiques (8 originales + 4 ajoutées) × 50 produits = 600 produits uniques
// ÉDITION LUXE & PRESTIGE — chaque univers propose des produits de luxe/prestige
// Currency: FCFA (Franc CFA) - matches original site

export interface Product {
  id: string;
  name: string;
  price: number; // FCFA
  origin: string;
  tag: string;
  description: string;
  boutiqueId: string;
  boutiqueName: string;
}

export interface Boutique {
  id: string;
  name: string;
  subtitle: string;
  countLabel: string;
  tagline: string;
  icon: string;
  accent: string;
  description: string;
  products: Product[];
}

export const boutiques: Boutique[] = [
  {
    id: "frais-marche",
    name: "Frais & Marché",
    subtitle: "Le Terroir Français d'Exception",
    countLabel: "50 produits d'exception",
    tagline: "Le meilleur du terroir français, sublimé",
    icon: "❖",
    accent: "#7d9b4e",
    description: "Le meilleur du terroir français sublimé : légumes anciens IGP, viandes Halal de races rares, poissons pêchés à la ligne, fromages AOP affinés en cave, et produits du terroir d'exception sélectionnés auprès de producteurs partenaires d'Île-de-France.",
    products: [
      {
        id: "frais-marche-001",
        name: "Panier garni royal : truffe, caviar, foie gras, champagne",
        price: 285000,
        origin: "France",
        tag: "Coffret",
        description: "Coffret prestige truffe noire, caviar, foie gras et champagne.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-002",
        name: "Caviar Beluga Malossol Iran 50g",
        price: 125000,
        origin: "Iran",
        tag: "Caviar",
        description: "Caviar Beluga Malossol premium, le plus rare du monde.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-003",
        name: "Caviar Osciètre Royal Iran 50g",
        price: 58000,
        origin: "Iran",
        tag: "Caviar",
        description: "Caviar Osciètre Royal millésime Iran.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-004",
        name: "Caviar Sevruga Iran 50g",
        price: 45000,
        origin: "Iran",
        tag: "Caviar",
        description: "Caviar Sevruga petit grain intense.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-005",
        name: "Truffe noire du Périgord fraîche, 25g",
        price: 125000,
        origin: "Dordogne",
        tag: "Condiment",
        description: "Tuber melanosporum fraîche de l'hiver périgourdin.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-006",
        name: "Truffe blanche d'Alba fraîche, 20g",
        price: 195000,
        origin: "Italie",
        tag: "Condiment",
        description: "Tuber magnatum pico d'Italie, reine des truffes.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-007",
        name: "Foie gras de canard mi-cuit du Sud-Ouest, bocal 500g",
        price: 32000,
        origin: "Landes",
        tag: "Apéritif",
        description: "Foie gras mi-cuit Gers élevé en liberté.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-008",
        name: "Foie gras d'oie entier truffé, bocal 200g",
        price: 38000,
        origin: "Gers",
        tag: "Apéritif",
        description: "Foie gras d'oie truffé à 3% de truffe noire.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-009",
        name: "Homard bleu de Bretagne vivant, 800g",
        price: 52000,
        origin: "Bretagne",
        tag: "Marée",
        description: "Homard bleu royal de la côte, pêche du jour.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-010",
        name: "Langouste royale de Bretagne, 1.2kg",
        price: 68000,
        origin: "Bretagne",
        tag: "Marée",
        description: "Langouste royale vivante du Guilvinec.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-011",
        name: "Saint-Jacques de plongée de Dieppe, 24 noix",
        price: 58000,
        origin: "Normandie",
        tag: "Marée",
        description: "Saint-Jacques de plongée, noix coraillées.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-012",
        name: "Turbot de l'Atlantique sauvage, 1.5kg",
        price: 78000,
        origin: "Bretagne",
        tag: "Marée",
        description: "Turbot sauvage de roche, ligne de pont.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-013",
        name: "Bar de ligne de Méditerranée, 1.2kg",
        price: 38000,
        origin: "Méditerranée",
        tag: "Marée",
        description: "Bar de ligne de Sète, pêche du jour.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-014",
        name: "Sole de petit bateau de Roscoff, 600g",
        price: 28000,
        origin: "Bretagne",
        tag: "Marée",
        description: "Sole franche de Roscoff premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-015",
        name: "Caviar d'Aubrac Premium 50g",
        price: 38000,
        origin: "Aveyron",
        tag: "Caviar",
        description: "Caviar d'esturgeon d'Aubrac fermier.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-016",
        name: "Filet de bœuf Wagyu A5 Japonais, 300g",
        price: 88000,
        origin: "Japon",
        tag: "Boucherie",
        description: "Wagyu A5 grade 12 persillé Japonais premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-017",
        name: "Côte de bœuf Black Angus maturée 60 jours Halal, 1.5kg",
        price: 75000,
        origin: "Bourgogne",
        tag: "Boucherie",
        description: "Race écossaise Black Angus, maturée 60 jours.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-018",
        name: "Filet de bœuf Charolais Halal, 1kg",
        price: 58000,
        origin: "Bourgogne",
        tag: "Boucherie",
        description: "Pièce noble, race bovine Charolaise premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-019",
        name: "Gigot d'agneau de Lozère Halal, 2.5kg",
        price: 45000,
        origin: "Lozère",
        tag: "Boucherie",
        description: "Agneau de pâturage de Lozère AOC.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-020",
        name: "Agneau de Pauillac Halal, 1/4 carcasse",
        price: 85000,
        origin: "Gironde",
        tag: "Boucherie",
        description: "Agneau de lait de Pauillac AOC premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-021",
        name: "Veau de l'Aveyron sous la mère Halal, 4 côtes",
        price: 65000,
        origin: "Aveyron",
        tag: "Boucherie",
        description: "Veau de lait Aveyron élevé sous la mère.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-022",
        name: "Poulet de Bresse AOP Halal, 2kg",
        price: 38000,
        origin: "Ain",
        tag: "Volaille",
        description: "Volaille AOP de Louhans, la seule AOP volaille.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-023",
        name: "Pintade fermière de Lozère Halal, 1.6kg",
        price: 18000,
        origin: "Lozère",
        tag: "Volaille",
        description: "Pintade fermière de Lozère prête à rôtir.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-024",
        name: "Pigeonneau royal Halal, 2 pièces",
        price: 22000,
        origin: "Bresse",
        tag: "Volaille",
        description: "Pigeonneau royal de Bresse premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-025",
        name: "Comté 36 mois Grand Cru, 250g",
        price: 12500,
        origin: "Jura",
        tag: "Fromage",
        description: "Affinage long en cave naturelle 36 mois.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-026",
        name: "Roquefort Société Réserve, 200g",
        price: 8500,
        origin: "Aveyron",
        tag: "Fromage",
        description: "Brebis Lacaune, caves naturelles Roquefort.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-027",
        name: "Brie de Meaux AOP au lait cru, 500g",
        price: 12000,
        origin: "Seine-et-Marne",
        tag: "Fromage",
        description: "Brie de Meaux AOP au lait cru fermier.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-028",
        name: "Camembert de Normandie AOP au lait cru",
        price: 8500,
        origin: "Normandie",
        tag: "Fromage",
        description: "Camembert AOP au lait cru fermier.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-029",
        name: "Munster au lait cru AOP affiné 12 semaines, 250g",
        price: 9500,
        origin: "Haut-Rhin",
        tag: "Fromage",
        description: "Affinage sur planches d'épicéa 12 semaines.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-030",
        name: "Morbier fermier AOP au lait cru, 250g",
        price: 7500,
        origin: "Jura",
        tag: "Fromage",
        description: "Morbier fermier à la traite du matin et soir.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-031",
        name: "Tomme de Savoie IGP au lait cru, 250g",
        price: 6500,
        origin: "Savoie",
        tag: "Fromage",
        description: "Tomme de Savoie IGP au lait cru fermier.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-032",
        name: "Salers AOP 18 mois, 250g",
        price: 11500,
        origin: "Cantal",
        tag: "Fromage",
        description: "Salers AOP de vaches Aubrac premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-033",
        name: "Époisses AOP Berthaut affiné, 250g",
        price: 9500,
        origin: "Côte-d'Or",
        tag: "Fromage",
        description: "Époisses affiné à la main, marc de Bourgogne.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-034",
        name: "Beurre AOP Charentes-Poitou baratte 250g",
        price: 4500,
        origin: "Poitou",
        tag: "Crémerie",
        description: "Beurre AOP baratte demi-sel Échiré.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-035",
        name: "Crème fraîche AOP d'Isigny épaisse 500ml",
        price: 3200,
        origin: "Normandie",
        tag: "Crémerie",
        description: "Crème fraîche AOP Isigny-sur-Mer premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-036",
        name: "Œufs frais de Marans chocolat, boîte 12",
        price: 6500,
        origin: "Charente-Maritime",
        tag: "Crémerie",
        description: "Œufs de Marans couleur chocolat premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-037",
        name: "Safran pur du Quercy, 2g",
        price: 25000,
        origin: "Lot",
        tag: "Épice",
        description: "Or rouge cultivé à Labastide-Murat.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-038",
        name: "Piment d'Espelette AOP en poudre, 40g",
        price: 8500,
        origin: "Pyrénées-Atlantiques",
        tag: "Épice",
        description: "Séché au vent d'Ezterenzuby AOP.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-039",
        name: "Ail rose de Lautrec AOP, 250g",
        price: 6500,
        origin: "Tarn",
        tag: "Frais",
        description: "Ail rose IGP de Lautrec Label Rouge.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-040",
        name: "Tomates anciennes de Provence premium, 1kg",
        price: 9800,
        origin: "Vaucluse",
        tag: "Frais",
        description: "Cœur de bœuf, Noire de Crimée, Ananas premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-041",
        name: "Fraises de Plougastel Mara des Bois, 500g",
        price: 12000,
        origin: "Finistère",
        tag: "Frais",
        description: "Variété parfumée de Plougastel premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-042",
        name: "Asperges vertes du Vaucluse premium, 500g",
        price: 14500,
        origin: "Vaucluse",
        tag: "Frais",
        description: "Pointes fines et fondantes premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-043",
        name: "Melon de Cavaillon IGP, 2 pièces",
        price: 8800,
        origin: "Vaucluse",
        tag: "Frais",
        description: "Melon Charentais jaune de Cavaillon IGP.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-044",
        name: "Citrons de Menton AOP premium, 1kg",
        price: 9500,
        origin: "Alpes-Maritimes",
        tag: "Frais",
        description: "Citrons doux AOP de Menton premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-045",
        name: "Raisin Chasselas de Moissac AOP, 500g",
        price: 9500,
        origin: "Tarn-et-Garonne",
        tag: "Frais",
        description: "Grappes dorées AOP de Moissac premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-046",
        name: "Abricot du Roussillon AOP, 500g",
        price: 12000,
        origin: "Pyrénées-Orientales",
        tag: "Frais",
        description: "Variété Rouge du Roussillon AOP premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-047",
        name: "Figue de Solliès AOP, 500g",
        price: 8500,
        origin: "Var",
        tag: "Frais",
        description: "Figue noire de Solliès AOP premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-048",
        name: "Truffe noire mélanosporum en bocal, 25g",
        price: 65000,
        origin: "Dordogne",
        tag: "Condiment",
        description: "Truffe noire du Périgord en bocal premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-049",
        name: "Cèpes frais du Périgord, 500g",
        price: 28500,
        origin: "Dordogne",
        tag: "Frais",
        description: "Cèpes fraîchement cueillis du Périgord.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
      {
        id: "frais-marche-050",
        name: "Morilles fraîches de France, 250g",
        price: 22000,
        origin: "Doubs",
        tag: "Frais",
        description: "Morilles fraîches de printemps premium.",
        boutiqueId: "frais-marche",
        boutiqueName: "Frais & Marché",
      },
    ],
  },
  {
    id: "epicerie-fine",
    name: "Épicerie Fine",
    subtitle: "Sélection du Maître",
    countLabel: "50 références prestige",
    tagline: "L'épicerie fine d'exception",
    icon: "✦",
    accent: "#8a6d3b",
    description: "L'épicerie fine d'exception : caviar Beluga et Osciètre, champagnes Dom Pérignon et Cristal, truffe noire du Périgord et blanche d'Alba, foie gras du Sud-Ouest, chocolats grand cru, cafés Blue Mountain et thés rares. Sélectionné par notre Maître Sommelier.",
    products: [
      {
        id: "epicerie-fine-001",
        name: "Coffret Grande Maison : Caviar, Champagne, Truffe",
        price: 285000,
        origin: "Importé",
        tag: "Coffret",
        description: "Caviar Beluga, champagne Dom Pérignon, truffe noire.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-002",
        name: "Coffret Royal : Truffe, Foie gras, Safran, Caviar",
        price: 215000,
        origin: "France",
        tag: "Coffret",
        description: "Coffret prestige truffe noire, foie gras, safran, caviar.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-003",
        name: "Caviar Beluga Malossol Iran 50g",
        price: 125000,
        origin: "Iran",
        tag: "Caviar",
        description: "Caviar Beluga Malossol premium, le plus rare du monde.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-004",
        name: "Caviar Osciètre Royal Iran 100g",
        price: 115000,
        origin: "Iran",
        tag: "Caviar",
        description: "Caviar Osciètre Royal millésime Iran 100g.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-005",
        name: "Caviar Sevruga Iran 100g",
        price: 88000,
        origin: "Iran",
        tag: "Caviar",
        description: "Caviar Sevruga petit grain intense 100g.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-006",
        name: "Caviar d'Aquitaine Baeri Premium 50g",
        price: 45000,
        origin: "Gironde",
        tag: "Caviar",
        description: "Caviar d'esturgeon baeri fermier d'Aquitaine.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-007",
        name: "Truffe noire du Périgord fraîche, 25g",
        price: 125000,
        origin: "Dordogne",
        tag: "Condiment",
        description: "Tuber melanosporum fraîche de l'hiver périgourdin.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-008",
        name: "Truffe blanche d'Alba fraîche, 20g",
        price: 195000,
        origin: "Italie",
        tag: "Condiment",
        description: "Tuber magnatum pico d'Italie, reine des truffes.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-009",
        name: "Truffe noire mélanosporum bocal 50g",
        price: 125000,
        origin: "Dordogne",
        tag: "Condiment",
        description: "Truffe entière en bocal premium du Périgord.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-010",
        name: "Foie gras d'oie entier truffé 200g",
        price: 38000,
        origin: "Gers",
        tag: "Apéritif",
        description: "Foie gras d'oie truffé à 5% de truffe noire.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-011",
        name: "Foie gras de canard mi-cuit du Sud-Ouest 500g",
        price: 32000,
        origin: "Landes",
        tag: "Apéritif",
        description: "Foie gras mi-cuit élevé en liberté, Landes.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-012",
        name: "Foie gras d'oie entier du Gers 300g",
        price: 28000,
        origin: "Gers",
        tag: "Apéritif",
        description: "Foie gras d'oie entier Gers, tradition gasconne.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-013",
        name: "Cassoulet castelnaudary tradition, bocal 1kg",
        price: 18000,
        origin: "Aude",
        tag: "Conserve",
        description: "Recette originelle du cassoulet de Castelnaudary premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-014",
        name: "Confit de canard du Sud-Ouest 6 cuisses",
        price: 18500,
        origin: "Gers",
        tag: "Conserve",
        description: "Confit fondant préparé selon la tradition gasconne.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-015",
        name: "Safran pur du Quercy, 2g",
        price: 25000,
        origin: "Lot",
        tag: "Épice",
        description: "Or rouge cultivé à Labastide-Murat.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-016",
        name: "Safran sargol Iran, 2g",
        price: 22000,
        origin: "Iran",
        tag: "Épice",
        description: "Safran sargol pur rouge Iranian premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-017",
        name: "Vanille Bourbon Madagascar premium 10 gousses",
        price: 19500,
        origin: "Madagascar",
        tag: "Épice",
        description: "Vanille planiflore bourbon longue premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-018",
        name: "Vanille Tahitensis Tahiti premium 10 gousses",
        price: 25000,
        origin: "Polynésie",
        tag: "Épice",
        description: "Vanille tahitienne fleurie premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-019",
        name: "Café Blue Mountain Jamaïque 250g",
        price: 29000,
        origin: "Jamaïque",
        tag: "Café",
        description: "Café arabica le plus rare du monde Blue Mountain.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-020",
        name: "Café Kopi Luwak Indonésie 100g",
        price: 95000,
        origin: "Indonésie",
        tag: "Café",
        description: "Café civette récolté en forêt Kopi Luwak.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-021",
        name: "Café Geisha Esmeralda Panama 250g",
        price: 32000,
        origin: "Panama",
        tag: "Café",
        description: "Lauréat Best of Panama Esmeralda Geisha.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-022",
        name: "Café Kona Hawaï 250g",
        price: 26000,
        origin: "Hawaï",
        tag: "Café",
        description: "Arabica cultivé sur les volcans hawaïens.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-023",
        name: "Thé Darjeeling First Flush Margareth's Hope 100g",
        price: 12500,
        origin: "Inde",
        tag: "Thé",
        description: "Première récolte printanière du Darjeeling premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-024",
        name: "Thé Matcha cérémonie Uji 50g",
        price: 28000,
        origin: "Japon",
        tag: "Thé",
        description: "Matcha cérémonial Uji de Kyoto premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-025",
        name: "Thé Gyokuro Asahi Shizuoka 50g",
        price: 29000,
        origin: "Japon",
        tag: "Thé",
        description: "Thé vert d'ombre précieux Gyokuro Asahi premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-026",
        name: "Thé Da Hong Pao Wuyi 50g",
        price: 29000,
        origin: "Chine",
        tag: "Thé",
        description: "Oolong Big Red Robe de Wuyi Da Hong Pao premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-027",
        name: "Thé Pu-erh millésimé 2007 Yunnan 100g",
        price: 18500,
        origin: "Chine",
        tag: "Thé",
        description: "Thé sombre vieilli Yunnan Pu-erh 2007 premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-028",
        name: "Chocolat Valrhona Manjari 70% tablette 70g",
        price: 5500,
        origin: "France",
        tag: "Chocolat",
        description: "Grand cru Madagascar 70% cacao Valrhona.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-029",
        name: "Chocolat Valrhona Guanaja 70% tablette 70g",
        price: 5500,
        origin: "France",
        tag: "Chocolat",
        description: "Grand cru intense Caraïbes 70% cacao.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-030",
        name: "Chocolat Bonnat Madagascar 75% tablette 100g",
        price: 6500,
        origin: "France",
        tag: "Chocolat",
        description: "Grand cru Bonnat Madagascar 75% cacao premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-031",
        name: "Coffret chocolats Pierre Hermé 36 pièces",
        price: 42000,
        origin: "Paris",
        tag: "Chocolat",
        description: "Coffret prestige Pierre Hermé Paris.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-032",
        name: "Coffret chocolats Valrhona grands crus 50 pièces",
        price: 38000,
        origin: "France",
        tag: "Chocolat",
        description: "Coffret grands crus Valrhona premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-033",
        name: "Coffret macarons Ladurée 48 pièces",
        price: 48000,
        origin: "Paris",
        tag: "Sucré",
        description: "Coffret prestige macarons Ladurée Paris.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-034",
        name: "Coffret macarons Pierre Hermé 36 pièces",
        price: 38000,
        origin: "Paris",
        tag: "Sucré",
        description: "Coffret prestige macarons Pierre Hermé Paris.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-035",
        name: "Calissons d'Aix Royale 18 pièces",
        price: 12500,
        origin: "Bouches-du-Rhône",
        tag: "Sucré",
        description: "Pâte de melon et amandes glaçage royal premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-036",
        name: "Miel de sapin des Vosges premium 500g",
        price: 8500,
        origin: "Vosges",
        tag: "Sucré",
        description: "Miel rarissime récolté en altitude premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-037",
        name: "Miel de châtaignier des Cévennes AOP 500g",
        price: 6500,
        origin: "Lozère",
        tag: "Sucré",
        description: "Miel AOP au goût boisé et persistant premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-038",
        name: "Miel de manuka UMF 20+ Nouvelle-Zélande 250g",
        price: 28000,
        origin: "Nouvelle-Zélande",
        tag: "Sucré",
        description: "Miel de manuka UMF 20+ premium antibactérien.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-039",
        name: "Huile d'olive vierge extra de Nyons AOP 75cl",
        price: 12500,
        origin: "Drôme",
        tag: "Huile",
        description: "Huile d'olive AOP de Nyons premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-040",
        name: "Huile de truffe noire du Périgord 25cl",
        price: 18500,
        origin: "Dordogne",
        tag: "Huile",
        description: "Huile d'olive infusée à la truffe noire premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-041",
        name: "Vinaigre balsamique de Modène 25 ans 25cl",
        price: 32000,
        origin: "Italie",
        tag: "Condiment",
        description: "Vinaigre balsamique traditionnel de Modène IGP premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-042",
        name: "Vinaigre de Xérès 30 ans premium 25cl",
        price: 18500,
        origin: "Importé",
        tag: "Condiment",
        description: "Vinaigre vieilli 30 ans en fûts de chêne.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-043",
        name: "Moutarde de Dijon Fallot au pain d'épices 200g",
        price: 5500,
        origin: "Côte-d'Or",
        tag: "Condiment",
        description: "Moutarde en grains au pain d'épices Fallot premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-044",
        name: "Jambon noir de Bigorre 36 mois 100g",
        price: 12500,
        origin: "Hautes-Pyrénées",
        tag: "Charcuterie",
        description: "Race porcine noir gasconne, affinage long premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-045",
        name: "Saucisson de canard fumé du Sud-Ouest 250g",
        price: 8500,
        origin: "Landes",
        tag: "Charcuterie",
        description: "Séché 6 semaines au feu de bois premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-046",
        name: "Anchois de Collioure au sel premium 200g",
        price: 8500,
        origin: "Pyrénées-Orientales",
        tag: "Apéritif",
        description: "Anchois pêchés en Méditerranée, salés 6 mois premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-047",
        name: "Tapenade noire de la Drôme premium 90g",
        price: 4500,
        origin: "Drôme",
        tag: "Apéritif",
        description: "Pâte d'olives noires et câpres premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-048",
        name: "Confit d'oignons au Sauternes premium 90g",
        price: 4500,
        origin: "Gironde",
        tag: "Condiment",
        description: "Oignons confits au Sauternes et vinaigre balsamique.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-049",
        name: "Gelée de coings de Provence premium 320g",
        price: 3800,
        origin: "Provence",
        tag: "Sucré",
        description: "Préparée en chaudron de cuivre premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
      {
        id: "epicerie-fine-050",
        name: "Confiture de figue de Solliès AOP premium 320g",
        price: 4800,
        origin: "Var",
        tag: "Sucré",
        description: "Figues noires de Solliès AOP premium.",
        boutiqueId: "epicerie-fine",
        boutiqueName: "Épicerie Fine",
      },
    ],
  },
  {
    id: "beaute-parfums",
    name: "Beauté & Parfums",
    subtitle: "Grands Parfumeurs",
    countLabel: "50 marques prestige",
    tagline: "Les plus grandes maisons de la beauté",
    icon: "❀",
    accent: "#b87c8a",
    description: "Les plus grandes maisons de la beauté : Chanel, Dior, Hermès, YSL, La Mer, Estée Lauder, Lancôme, Sisley. Parfums iconiques, soins du visage, maquillage et coffrets cadeaux. Authenticité garantie, conseillères beauté à votre disposition.",
    products: [
      {
        id: "beaute-parfums-001",
        name: "Coffret Beauté Dior prestige : J'adore + Capture Totale",
        price: 185000,
        origin: "Paris",
        tag: "Coffret",
        description: "Parfum J'adore EDP 100ml + sérum Capture Totale Dior.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-002",
        name: "Coffret Chanel Coco Mademoiselle prestige",
        price: 220000,
        origin: "Paris",
        tag: "Coffret",
        description: "Coffret Mademoiselle EDP 100ml + rouge Chanel prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-003",
        name: "Coffret Hermès Terre d'Hermès prestige",
        price: 165000,
        origin: "Paris",
        tag: "Coffret",
        description: "Coffret Terre d'Hermès EDT 100ml + gel douche prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-004",
        name: "Parfum Chanel N°5 Eau de Parfum 100ml",
        price: 75000,
        origin: "Paris",
        tag: "Parfum",
        description: "Iconique parfum d'Ernest Beaux 1921 prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-005",
        name: "Parfum Chanel N°5 Extrait 7.5ml",
        price: 95000,
        origin: "Paris",
        tag: "Parfum",
        description: "Extrait prestige de Chanel N°5 flacon Baccarat.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-006",
        name: "Parfum Dior J'adore Eau de Parfum 100ml",
        price: 62000,
        origin: "Paris",
        tag: "Parfum",
        description: "Calice de fleurs de Calice Becker prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-007",
        name: "Parfum Dior Sauvage Elixir 100ml",
        price: 85000,
        origin: "Paris",
        tag: "Parfum",
        description: "Elixir prestige intenso Dior Sauvage.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-008",
        name: "Parfum Guerlain Shalimar Eau de Parfum 75ml",
        price: 65000,
        origin: "Paris",
        tag: "Parfum",
        description: "Oriental légendaire de 1925 prestige Guerlain.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-009",
        name: "Parfum Hermès Terre d'Hermès 100ml",
        price: 55000,
        origin: "Paris",
        tag: "Parfum",
        description: "Bois et minéral de Jean-Claude Ellena prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-010",
        name: "Parfum Hermès 24 Faubourg Eau de Parfum 100ml",
        price: 75000,
        origin: "Paris",
        tag: "Parfum",
        description: "Fleur d'oranger et jasmin prestige Hermès.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-011",
        name: "Parfum Yves Saint Laurent Black Opium 90ml",
        price: 62000,
        origin: "Paris",
        tag: "Parfum",
        description: "Café et vanille audacieuse YSL prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-012",
        name: "Parfum YSL Libre Intense 90ml",
        price: 75000,
        origin: "Paris",
        tag: "Parfum",
        description: "Lavande et orange fleur YSL Libre Intense prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-013",
        name: "Parfum Tom Ford Black Orchid 100ml",
        price: 95000,
        origin: "États-Unis",
        tag: "Parfum",
        description: "Orient noir sensuel Tom Ford prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-014",
        name: "Parfum Tom Ford Oud Wood 100ml",
        price: 125000,
        origin: "États-Unis",
        tag: "Parfum",
        description: "Oud et bois précieux Tom Ford prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-015",
        name: "Parfum Creed Aventus 100ml",
        price: 165000,
        origin: "France",
        tag: "Parfum",
        description: "Fruits noirs et bouleau Creed prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-016",
        name: "Parfum Maison Francis Kurkdjian Baccarat Rouge 540 70ml",
        price: 125000,
        origin: "Paris",
        tag: "Parfum",
        description: "Safran et ambre lumineux MFK prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-017",
        name: "Parfum MFK Aqua Universalis 70ml",
        price: 95000,
        origin: "Paris",
        tag: "Parfum",
        description: "Fleur de bergamote et muguet MFK prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-018",
        name: "Parfum Jo Malone Wood Sage & Sea Salt 100ml",
        price: 75000,
        origin: "Londres",
        tag: "Parfum",
        description: "Mer et sauge marine Jo Malone prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-019",
        name: "Parfum Le Labo Santal 33 50ml",
        price: 95000,
        origin: "États-Unis",
        tag: "Parfum",
        description: "Santal culte de Brooklyn Le Labo prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-020",
        name: "Parfum Diptyque Philosykos 75ml",
        price: 62000,
        origin: "Paris",
        tag: "Parfum",
        description: "Feuilles de figuier méditerranéen Diptyque prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-021",
        name: "Crème La Mer The Moisturizing Softener 60ml",
        price: 145000,
        origin: "États-Unis",
        tag: "Soin visage",
        description: "Crème Miracle Broth La Mer prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-022",
        name: "Crème La Mer The Concentrate 50ml",
        price: 285000,
        origin: "États-Unis",
        tag: "Soin visage",
        description: "Concentré Miracle Broth La Mer prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-023",
        name: "Crème Sublimatrice Sisley Paris 50ml",
        price: 195000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Crème jour haute nutrition Sisley prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-024",
        name: "Sérum Black Orchid La Prairie 30ml",
        price: 425000,
        origin: "Suisse",
        tag: "Soin visage",
        description: "Sérum régénérant caviar La Prairie prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-025",
        name: "Crème La Prairie Skin Caviar 50ml",
        price: 545000,
        origin: "Suisse",
        tag: "Soin visage",
        description: "Crème caviar liftant La Prairie prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-026",
        name: "Crème Chanel Sublimage La Crème 50ml",
        price: 185000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Extrait de vanille de Madagascar Chanel prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-027",
        name: "Sérum Dior Capture Totale Super Potent 30ml",
        price: 95000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Sérum multi-perfection Dior prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-028",
        name: "Crème Lancôme Absolue Premium 60ml",
        price: 125000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Crème à la rose Lancôme prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-029",
        name: "Sérum Yves Saint Laurent Or Rouge 30ml",
        price: 125000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Extrait de pistache de l'Atlas YSL prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-030",
        name: "Crème Guerlain Orchidée Impériale 50ml",
        price: 165000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Extrait d'orchidée noire Guerlain prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-031",
        name: "Sérum Estée Lauder Advanced Night Repair 50ml",
        price: 55000,
        origin: "États-Unis",
        tag: "Soin visage",
        description: "Sérum de nuit historique Estée Lauder prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-032",
        name: "Masque La Prairie Skin Caviar 50ml",
        price: 225000,
        origin: "Suisse",
        tag: "Soin visage",
        description: "Masque liftant caviar La Prairie prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-033",
        name: "Crème Clarins Extra-Firming Nights 50ml",
        price: 42000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Crème nuit fermeté Clarins prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-034",
        name: "Rouge à lèvres Chanel Rouge Allure 6g",
        price: 18500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Rouge intense longue tenue Chanel prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-035",
        name: "Rouge à lèvres Dior Rouge 999 6g",
        price: 18500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Rouge iconique 999 de Dior prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-036",
        name: "Rouge à lèvres Tom Ford Lip Color 3g",
        price: 26500,
        origin: "États-Unis",
        tag: "Maquillage",
        description: "Rouge crémeux luxe Tom Ford prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-037",
        name: "Rouge à lèvres Hermès 24 Faubourg 3g",
        price: 28500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Rouge Hermès cuir prestige Paris.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-038",
        name: "Fond de teint Armani Luminous Silk 30ml",
        price: 32000,
        origin: "Italie",
        tag: "Maquillage",
        description: "Fond de teint soie lumineuse Armani prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-039",
        name: "Fond de teint Dior Forever Skin Glow 30ml",
        price: 28500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Éclat naturel longue tenue Dior prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-040",
        name: "Fond de teint Chanel Le Teint 30ml",
        price: 32500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Teint Lumière naturelle Chanel prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-041",
        name: "Palette fards Dior Backstage 6 teintes",
        price: 32500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Palette professionnelle Dior prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-042",
        name: "Palette fards Charlotte Tilbury 12 teintes",
        price: 32500,
        origin: "Londres",
        tag: "Maquillage",
        description: "Palette Pillow Talk Charlotte Tilbury prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-043",
        name: "Mascara Lancôme Hypnôse Drama 27.5ml",
        price: 18500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Volume intense et longueur Lancôme prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-044",
        name: "Mascara YSL Lash Clash 28.5ml",
        price: 19500,
        origin: "Paris",
        tag: "Maquillage",
        description: "Brosse XXL volume YSL prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-045",
        name: "Anti-cernes NARS Radiant Creamy 6ml",
        price: 16500,
        origin: "États-Unis",
        tag: "Maquillage",
        description: "Correcteur crémeux lumineux NARS prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-046",
        name: "Soin yeux Sisley Eye Contour 15ml",
        price: 95000,
        origin: "Paris",
        tag: "Soin yeux",
        description: "Contour des yeux botanique Sisley prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-047",
        name: "Crème mains Hermès 100ml",
        price: 18500,
        origin: "Paris",
        tag: "Soin corps",
        description: "Crème mains cuir d'Hermès prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-048",
        name: "Bougie Diptyque Baies 600g prestige",
        price: 48000,
        origin: "Paris",
        tag: "Bougie",
        description: "Senteur baies et feuilles de buis Diptyque prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-049",
        name: "Bougie Cire Trudon Ernesto 800g prestige",
        price: 52000,
        origin: "Paris",
        tag: "Bougie",
        description: "Cire végétale à la main Cire Trudon prestige.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
      {
        id: "beaute-parfums-050",
        name: "Coffret parfum Hermès 24 Faubourg + Twilly prestige",
        price: 195000,
        origin: "Paris",
        tag: "Coffret",
        description: "Coffret prestige Hermès 24 Faubourg EDP + Twilly soie.",
        boutiqueId: "beaute-parfums",
        boutiqueName: "Beauté & Parfums",
      },
    ],
  },
  {
    id: "hightech-electro",
    name: "High-Tech & Électro",
    subtitle: "Galerie Numérique Premium",
    countLabel: "50 produits prestige",
    tagline: "Le meilleur de la technologie",
    icon: "◈",
    accent: "#4a5d7d",
    description: "Le meilleur de la technologie premium : Apple, Samsung, Sony, Bang & Olufsen, Bose, Sonos, Leica, Hasselblad. Smartphones dernière génération, ordinateurs, audio premium, TV OLED 4K, objets connectés et appareils photo de prestige. Garanties officielles, installation à domicile.",
    products: [
      {
        id: "hightech-electro-001",
        name: "iPhone 16 Pro Max 1To Titane Naturel",
        price: 1285000,
        origin: "États-Unis",
        tag: "Smartphone",
        description: "Puce A18 Pro, écran 6.9 pouces, USB-C prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-002",
        name: "iPhone 16 Pro Max 1To Titane Désert",
        price: 1325000,
        origin: "États-Unis",
        tag: "Smartphone",
        description: "Édition prestige titane désert Apple.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-003",
        name: "Samsung Galaxy S25 Ultra 1To Titanium Black",
        price: 1185000,
        origin: "Corée du Sud",
        tag: "Smartphone",
        description: "Stylus S Pen, écran QHD+ 6.9 pouces, IA Gemini prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-004",
        name: "Samsung Galaxy Z Fold 6 1To prestige",
        price: 1850000,
        origin: "Corée du Sud",
        tag: "Smartphone",
        description: "Écran pliable premium Galaxy Z Fold 6 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-005",
        name: "Google Pixel 9 Pro XL 1To prestige",
        price: 985000,
        origin: "États-Unis",
        tag: "Smartphone",
        description: "IA Gemini Nano intégrée Google Pixel prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-006",
        name: "Vertu Signature Touch Cobra Limited Edition",
        price: 8500000,
        origin: "Royaume-Uni",
        tag: "Smartphone",
        description: "Smartphone de luxe Vertu cuir et titane prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-007",
        name: "MacBook Pro 16 pouces M4 Max 2To",
        price: 3450000,
        origin: "États-Unis",
        tag: "Ordinateur",
        description: "Puce M4 Max, 48 Go RAM, SSD 2To prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-008",
        name: "MacBook Pro 16 pouces M4 Max 4To 36Go",
        price: 4250000,
        origin: "États-Unis",
        tag: "Ordinateur",
        description: "Puce M4 Max, 36 Go RAM, SSD 4To prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-009",
        name: "MacBook Air 15 pouces M3 1To",
        price: 1450000,
        origin: "États-Unis",
        tag: "Ordinateur",
        description: "Léger, autonomie 18h, M3 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-010",
        name: "Dell XPS 15 OLED i9 32Go 2To",
        price: 2350000,
        origin: "États-Unis",
        tag: "Ordinateur",
        description: "Écran OLED tactile 4K Dell XPS prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-011",
        name: "Asus ROG Zephyrus G16 RTX 4090 32Go 2To",
        price: 2850000,
        origin: "Taïwan",
        tag: "Ordinateur",
        description: "PC gamer haut de gamme Asus ROG prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-012",
        name: "iPad Pro 13 pouces M4 2To Wi-Fi+Cellular",
        price: 1850000,
        origin: "États-Unis",
        tag: "Tablette",
        description: "Écran Ultra Retina XDR tandem prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-013",
        name: "iPad Pro 13 pouces M4 2To + Apple Pencil Pro",
        price: 1950000,
        origin: "États-Unis",
        tag: "Tablette",
        description: "Pack créatif iPad Pro M4 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-014",
        name: "Samsung Galaxy Tab S10 Ultra 1To",
        price: 1250000,
        origin: "Corée du Sud",
        tag: "Tablette",
        description: "Écran AMOLED 14.6 pouces prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-015",
        name: "Microsoft Surface Laptop Studio 2 2To",
        price: 2450000,
        origin: "États-Unis",
        tag: "Ordinateur",
        description: "Écran tactile 14.4 pouces RTX 4060 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-016",
        name: "Apple Watch Ultra 2 GPS+Cellulaire 49mm Titane",
        price: 725000,
        origin: "États-Unis",
        tag: "Montre connectée",
        description: "Résistance 100m, mode plongée prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-017",
        name: "Apple Watch Series 10 GPS 46mm prestige",
        price: 385000,
        origin: "États-Unis",
        tag: "Montre connectée",
        description: "Cadran large, santé avancée Apple Watch prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-018",
        name: "Garmin Fenix 8 Solar 47mm Sapphire",
        price: 950000,
        origin: "États-Unis",
        tag: "Montre connectée",
        description: "Recharge solaire, verre saphir prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-019",
        name: "Garmin Marq Gen2 Aviator premium",
        price: 1850000,
        origin: "États-Unis",
        tag: "Montre connectée",
        description: "Montre premium aviateur Garmin Marq prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-020",
        name: "AirPods Pro 2 USB-C prestige",
        price: 235000,
        origin: "États-Unis",
        tag: "Audio",
        description: "Réduction de bruit adaptative Apple prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-021",
        name: "AirPods Max Bleu Nuit prestige",
        price: 495000,
        origin: "États-Unis",
        tag: "Audio",
        description: "Casque hi-fi premium Apple prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-022",
        name: "Sony WH-1000XM5 Noir prestige",
        price: 325000,
        origin: "Japon",
        tag: "Audio",
        description: "Casque sans fil référence Sony prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-023",
        name: "Bose QuietComfort Ultra Noir prestige",
        price: 345000,
        origin: "États-Unis",
        tag: "Audio",
        description: "Audio immersif spatial Bose prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-024",
        name: "Sonos Era 300 prestige",
        price: 385000,
        origin: "États-Unis",
        tag: "Audio",
        description: "Enceinte Dolby Atmos Sonos Era 300 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-025",
        name: "Sonos Arc Pro Blanc prestige",
        price: 850000,
        origin: "États-Unis",
        tag: "Audio",
        description: "Barre de son Dolby Atmos Sonos Arc Pro prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-026",
        name: "Bang & Olufsen Beoplay H95 prestige",
        price: 1850000,
        origin: "Danemark",
        tag: "Audio",
        description: "Casque premium luxe B&O prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-027",
        name: "Bang & Olufsen Beosound A9 Gen 7 prestige",
        price: 3250000,
        origin: "Danemark",
        tag: "Audio",
        description: "Enceinte design premium B&O A9 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-028",
        name: "Bang & Olufsen Beosound Theatre prestige",
        price: 4500000,
        origin: "Danemark",
        tag: "Audio",
        description: "Barre de son design premium B&O Theatre prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-029",
        name: "Samsung TV OLED 65 pouces 4K S95D prestige",
        price: 1450000,
        origin: "Corée du Sud",
        tag: "TV",
        description: "OLED 4K 120Hz Smart TV prestige Samsung.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-030",
        name: "Sony Bravia XR-65A95L OLED 4K prestige",
        price: 2350000,
        origin: "Japon",
        tag: "TV",
        description: "OLED QD 65 pouces 120Hz Sony prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-031",
        name: "LG OLED evo G4 77 pouces prestige",
        price: 3850000,
        origin: "Corée du Sud",
        tag: "TV",
        description: "OLED 4K 120Hz Alpha 9 LG G4 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-032",
        name: "Samsung Neo QLED 8K QN900D 85 pouces prestige",
        price: 5450000,
        origin: "Corée du Sud",
        tag: "TV",
        description: "Mini LED 8K 1500 nits Samsung prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-033",
        name: "Bang & Olufsen Beovision Harmony 65 pouces",
        price: 8500000,
        origin: "Danemark",
        tag: "TV",
        description: "TV design premium B&O Beovision Harmony prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-034",
        name: "PlayStation 5 Pro 2To prestige",
        price: 625000,
        origin: "Japon",
        tag: "Console",
        description: "PS5 Pro enhanced 4K 60fps Sony prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-035",
        name: "Xbox Series X 2To Carbon Black prestige",
        price: 495000,
        origin: "États-Unis",
        tag: "Console",
        description: "Xbox Series X 2To Microsoft prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-036",
        name: "Nintendo Switch OLED Blanc prestige",
        price: 285000,
        origin: "Japon",
        tag: "Console",
        description: "Écran OLED 7 pouces Nintendo Switch prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-037",
        name: "Steam Deck OLED 1To prestige",
        price: 550000,
        origin: "États-Unis",
        tag: "Console",
        description: "Console portable Steam HDR Valve prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-038",
        name: "Appareil photo Leica Q3 60MP prestige",
        price: 4250000,
        origin: "Allemagne",
        tag: "Photo",
        description: "Compact plein format Leica Q3 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-039",
        name: "Appareil photo Leica M11 60MP prestige",
        price: 5850000,
        origin: "Allemagne",
        tag: "Photo",
        description: "Télémétrique plein format Leica M11 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-040",
        name: "Appareil photo Hasselblad X2D 100C prestige",
        price: 6850000,
        origin: "Suède",
        tag: "Photo",
        description: "Moyen format 100MP Hasselblad X2D prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-041",
        name: "Appareil photo Sony A1 II 50MP prestige",
        price: 4250000,
        origin: "Japon",
        tag: "Photo",
        description: "Hybride 50MP 8K vidéo Sony A1 II prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-042",
        name: "Objectif Canon RF 70-200mm f2.8 L IS prestige",
        price: 2450000,
        origin: "Japon",
        tag: "Photo",
        description: "Téléobjectif stabilisé Canon RF prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-043",
        name: "Objectif Leica Summilux-M 50mm f1.4 prestige",
        price: 2250000,
        origin: "Allemagne",
        tag: "Photo",
        description: "Objectif Leica Summilux-M prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-044",
        name: "Drone DJI Mavic 3 Pro Cine Premium prestige",
        price: 3850000,
        origin: "Chine",
        tag: "Drone",
        description: "Triple caméra Hasselblad DJI Mavic 3 Pro prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-045",
        name: "Drone DJI Inspire 3 + Zenmuse X9-8K Air prestige",
        price: 12500000,
        origin: "Chine",
        tag: "Drone",
        description: "Drone cinématographique 8K DJI Inspire 3 prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-046",
        name: "Casque Meta Quest 3 Pro 512Go prestige",
        price: 685000,
        origin: "États-Unis",
        tag: "VR",
        description: "Casque VR autonome mixed reality Meta prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-047",
        name: "Apple Vision Pro 1To prestige",
        price: 3250000,
        origin: "États-Unis",
        tag: "VR",
        description: "Casque spatial mixed reality Apple Vision Pro prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-048",
        name: "Écran Apple Pro Display XDR 32 pouces 6K prestige",
        price: 2850000,
        origin: "États-Unis",
        tag: "Écran",
        description: "Retina 6K HDR Apple Pro Display prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-049",
        name: "NAS Synology RS1221+ 8 baies prestige",
        price: 1250000,
        origin: "Taïwan",
        tag: "Stockage",
        description: "NAS pro 8 baies Synology RS1221+ prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
      {
        id: "hightech-electro-050",
        name: "Apple HomePod 2ème génération prestige",
        price: 185000,
        origin: "États-Unis",
        tag: "Audio",
        description: "Enceinte intelligente Apple HomePod prestige.",
        boutiqueId: "hightech-electro",
        boutiqueName: "High-Tech & Électro",
      },
    ],
  },
  {
    id: "mode-maison",
    name: "Mode & Maison",
    subtitle: "Maisons d'Exception",
    countLabel: "120 marques prestige",
    tagline: "Mode, maison et art de vivre",
    icon: "❧",
    accent: "#8a6d6d",
    description: "Mode, maison et art de vivre réunis en un seul écrin. Maroquinerie d'exception, prêt-à-porter signature, décoration d'intérieur, linge de maison et accessoires de table. 120 maisons : Hermès, Louis Vuitton, Chanel, Dior, Loewe, Bottega Veneta, et les grandes maisons de décoration françaises.",
    products: [
      {
        id: "mode-maison-001",
        name: "Sac Birkin 30 Togo Gold Hermès",
        price: 9500000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Birkin 30 cuir Togo coloris Gold Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-002",
        name: "Sac Birkin 25 Togo Noir Hermès",
        price: 8500000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Birkin 25 cuir Togo Noir Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-003",
        name: "Sac Kelly 28 Sellier Étoupe Hermès",
        price: 10500000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Kelly Sellier cuir Box Étoupe Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-004",
        name: "Sac Kelly 32 Sellier Noir Hermès",
        price: 11500000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Kelly Sellier cuir Box Noir Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-005",
        name: "Sac Constance 24 Noir Hermès",
        price: 6800000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Constance à rabat logo H Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-006",
        name: "Sac 2.55 Reissue 226 Chanel",
        price: 6250000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Mademoiselle 1955 mailles dorées Chanel prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-007",
        name: "Sac Classic Flap Medium Chanel",
        price: 6850000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Flap matelassé CC tournant Chanel prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-008",
        name: "Sac Boy Chanel Medium",
        price: 4250000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Boy agressif cuir veau Chanel prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-009",
        name: "Sac Capucines BB Louis Vuitton",
        price: 4850000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Capucines cuir Taurillon Louis Vuitton prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-010",
        name: "Sac Twist MM Louis Vuitton",
        price: 4450000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Twist cuir Epi Louis Vuitton prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-011",
        name: "Sac OnTheGo MM Louis Vuitton",
        price: 2450000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "OnTheGo jacquard géant Louis Vuitton prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-012",
        name: "Sac Goyard Saint-Louis PM Bleu",
        price: 1250000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Saint-Louis toile coloris Goyard prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-013",
        name: "Sac Lady Dior Medium",
        price: 4450000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Lady Dior cannage fourreau Dior prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-014",
        name: "Sac Saddle Bleu Nuit Dior",
        price: 2850000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Saddle cuir Oblique Dior prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-015",
        name: "Sac Le Cagole YSL Medium",
        price: 2250000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Le Cagole bijoux cloutés YSL prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-016",
        name: "Sac Gucci Jackie 1961 Medium",
        price: 1850000,
        origin: "Italie",
        tag: "Maroquinerie",
        description: "Jackie originelle cavaliche Gucci prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-017",
        name: "Sac Prada Galleria Saffiano Medium",
        price: 2150000,
        origin: "Italie",
        tag: "Maroquinerie",
        description: "Galleria cuir Saffiano Prada prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-018",
        name: "Sac Loewe Puzzle Small",
        price: 2250000,
        origin: "Espagne",
        tag: "Maroquinerie",
        description: "Puzzle géométrique cuir Loewe prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-019",
        name: "Sac Bottega Veneta Cassette",
        price: 2450000,
        origin: "Italie",
        tag: "Maroquinerie",
        description: "Cassette intrecciato Bottega Veneta prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-020",
        name: "Sac Celine Triomphe Canvas",
        price: 1450000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Triomphe toile canons Celine prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-021",
        name: "Sac Fendi Peekaboo ISeeU Small",
        price: 2850000,
        origin: "Italie",
        tag: "Maroquinerie",
        description: "Peekaboo double compartiment Fendi prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-022",
        name: "Portefeuille Hermès Dogon Combination",
        price: 950000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Dogon porte-cartes cuir Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-023",
        name: "Portefeuille Chanel Classic Zipped",
        price: 750000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Portefeuille CC matelassé Chanel prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-024",
        name: "Portefeuille Louis Vuitton Victorine",
        price: 385000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Victorine Monogram Louis Vuitton prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-025",
        name: "Ceinture Hermès H noir 32mm",
        price: 585000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Ceinture H boucle métal palladiée Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-026",
        name: "Ceinture Hermès Constance 24mm",
        price: 495000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Ceinture Constance boucle H Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-027",
        name: "Ceinture Gucci GG Marmont noir",
        price: 285000,
        origin: "Italie",
        tag: "Maroquinerie",
        description: "GG Marmont boucle double G Gucci prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-028",
        name: "Ceinture Louis Vuitton LV Initiales 40mm",
        price: 385000,
        origin: "Paris",
        tag: "Maroquinerie",
        description: "Ceinture Initiales damier Louis Vuitton prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-029",
        name: "Lunettes Chanel Soleil Round CC",
        price: 385000,
        origin: "Paris",
        tag: "Lunetterie",
        description: "Lunettes solaires round CC Chanel prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-030",
        name: "Lunettes Dior So Real Pop",
        price: 445000,
        origin: "Paris",
        tag: "Lunetterie",
        description: "So Real Pop oversize Dior prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-031",
        name: "Lunettes Gucci Oversize Gold",
        price: 325000,
        origin: "Italie",
        tag: "Lunetterie",
        description: "Oversize cadre or Gucci prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-032",
        name: "Lunettes Saint Laurent Cat-eye",
        price: 345000,
        origin: "Paris",
        tag: "Lunetterie",
        description: "Cat-eye YSL logo gravé Saint Laurent prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-033",
        name: "Carré Hermès 90 soie Cosmos",
        price: 385000,
        origin: "Paris",
        tag: "Textile",
        description: "Carré 90 soie twill roulotté main Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-034",
        name: "Carré Hermès 90 soie Bride de Gala",
        price: 425000,
        origin: "Paris",
        tag: "Textile",
        description: "Carré 90 soie twill roulotté main Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-035",
        name: "Écharpe Hermès Twilly Color Singulier",
        price: 125000,
        origin: "Paris",
        tag: "Textile",
        description: "Twilly soie 86x5cm Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-036",
        name: "Foulard Hermès 70 soie Sellier",
        price: 245000,
        origin: "Paris",
        tag: "Textile",
        description: "Foulard 70 soie sellier Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-037",
        name: "Étole Hermès 100% cashmere",
        price: 485000,
        origin: "Paris",
        tag: "Textile",
        description: "Étole cashmere 200x70cm Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-038",
        name: "Vase Lalique Tourbillon 22cm",
        price: 425000,
        origin: "Moselle",
        tag: "Décoration",
        description: "Cristal moulé main motif tourbillon Lalique prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-039",
        name: "Vase Baccarat Harcourt 1841 24cm",
        price: 385000,
        origin: "Meurthe-et-Moselle",
        tag: "Décoration",
        description: "Cristal légendaire Baccarat Harcourt prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-040",
        name: "Verres Baccarat Harcourt set de 6",
        price: 425000,
        origin: "Meurthe-et-Moselle",
        tag: "Verrerie",
        description: "Verres cristal taille impériale Baccarat prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-041",
        name: "Couverts Christofle Malmaison 6 fourchettes",
        price: 385000,
        origin: "Paris",
        tag: "Argenterie",
        description: "Argent massif plaqué Christofle Malmaison prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-042",
        name: "Théière Christofle Malmaison prestige",
        price: 285000,
        origin: "Paris",
        tag: "Argenterie",
        description: "Théière argent massif Christofle prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-043",
        name: "Assiettes Bernardaud Louvre 12 pièces",
        price: 425000,
        origin: "Limousin",
        tag: "Porcelaine",
        description: "Service 12 assiettes Limousin Bernardaud prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-044",
        name: "Tasses Hermès Mosaique au 24 set de 2",
        price: 185000,
        origin: "Paris",
        tag: "Porcelaine",
        description: "Tasses café porcelaine Hermès prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-045",
        name: "Verres Riedel Sommelier Bordeaux set de 2",
        price: 145000,
        origin: "Autriche",
        tag: "Verrerie",
        description: "Verres grands vins rouges Riedel prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-046",
        name: "Drap-housse Le Jacquard Français Sologne",
        price: 75000,
        origin: "Vosges",
        tag: "Linge",
        description: "Drap-housse coton tissé Le Jacquard prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-047",
        name: "Serviettes Abyss & Habidek 70x140",
        price: 42500,
        origin: "Belgique",
        tag: "Linge",
        description: "Serviettes égyptiennes 600g/m² prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-048",
        name: "Parure de lit Le Jacquard Français Vence",
        price: 285000,
        origin: "Vosges",
        tag: "Linge",
        description: "Parure complète jacquard Le Jacquard prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-049",
        name: "Bougie Cire Trudon Ernesto 800g prestige",
        price: 62000,
        origin: "Paris",
        tag: "Bougie",
        description: "Cire végétale à la main Cire Trudon prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
      {
        id: "mode-maison-050",
        name: "Miroir solaire doré Baccarat 80cm",
        price: 245000,
        origin: "France",
        tag: "Décoration",
        description: "Miroir soleil doré à la feuille prestige.",
        boutiqueId: "mode-maison",
        boutiqueName: "Mode & Maison",
      },
    ],
  },
  {
    id: "cave-exception",
    name: "Cave d'Exception",
    subtitle: "Vins & Spiritueux",
    countLabel: "800 références prestige",
    tagline: "La cave d'exception",
    icon: "❦",
    accent: "#6e1f2a",
    description: "Une cave de 800 références, animée par un maître sommelier. Vins de Bordeaux, Bourgogne, Champagne, Rhône et Loire, mais aussi spiritueux d'exception : cognacs, whiskies, armagnacs et rhums millésimés. Dégustations privées chaque jeudi soir, accords mets & vins sur réservation.",
    products: [
      {
        id: "cave-exception-001",
        name: "Coffret Cave d'Exception 6 bouteilles prestige",
        price: 285000,
        origin: "France",
        tag: "Coffret",
        description: "Sélection prestige Bordeaux Bourgogne Rhône Champagne.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-002",
        name: "Domaine de la Romanée-Conti 2018, 75cl",
        price: 16500000,
        origin: "Bourgogne",
        tag: "Vin rouge",
        description: "Légende absolue de Vosne-Romanée DRC prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-003",
        name: "Domaine de la Romanée-Conti Montrachet 2018, 75cl",
        price: 12500000,
        origin: "Bourgogne",
        tag: "Vin blanc",
        description: "Grand cru blanc légendaire DRC Montrachet prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-004",
        name: "Château Pétrus 2017, 75cl",
        price: 2850000,
        origin: "Pomerol",
        tag: "Vin rouge",
        description: "Légende de Pomerol, merlot pur Pétrus prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-005",
        name: "Château Pétrus 2015, 75cl",
        price: 2450000,
        origin: "Pomerol",
        tag: "Vin rouge",
        description: "Légende de Pomerol, merlot pur Pétrus prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-006",
        name: "Château Lafite Rothschild 2018, 75cl",
        price: 950000,
        origin: "Pauillac",
        tag: "Vin rouge",
        description: "Premier cru classé de Bordeaux Lafite Rothschild prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-007",
        name: "Château Margaux 2017, 75cl",
        price: 750000,
        origin: "Margaux",
        tag: "Vin rouge",
        description: "Premier cru classé, élégance pure Margaux prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-008",
        name: "Château Latour 2016, 75cl",
        price: 880000,
        origin: "Pauillac",
        tag: "Vin rouge",
        description: "Premier cru puissant de garde Latour prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-009",
        name: "Château Haut-Brion 2019, 75cl",
        price: 625000,
        origin: "Pessac-Léognan",
        tag: "Vin rouge",
        description: "Premier cru des Graves Haut-Brion prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-010",
        name: "Château Mouton Rothschild 2018, 75cl",
        price: 725000,
        origin: "Pauillac",
        tag: "Vin rouge",
        description: "Premier cru classé, étiquette d'art Mouton prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-011",
        name: "Château Cheval Blanc 2017, 75cl",
        price: 825000,
        origin: "Saint-Émilion",
        tag: "Vin rouge",
        description: "Premier grand cru classé A Cheval Blanc prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-012",
        name: "Château Ausone 2018, 75cl",
        price: 950000,
        origin: "Saint-Émilion",
        tag: "Vin rouge",
        description: "Premier grand cru classé A Ausone prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-013",
        name: "Château Le Pin 2017, 75cl",
        price: 2850000,
        origin: "Pomerol",
        tag: "Vin rouge",
        description: "Micro-cuvée légendaire de Pomerol Le Pin prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-014",
        name: "Domaine Leflaive Bâtard-Montrachet 2019, 75cl",
        price: 425000,
        origin: "Bourgogne",
        tag: "Vin blanc",
        description: "Grand cru blanc légendaire Leflaive prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-015",
        name: "Domaine Leflaive Montrachet 2018, 75cl",
        price: 850000,
        origin: "Bourgogne",
        tag: "Vin blanc",
        description: "Grand cru blanc absolu Leflaive Montrachet prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-016",
        name: "Côte-Rôtie La Mouline Guigal 2018, 75cl",
        price: 215000,
        origin: "Rhône",
        tag: "Vin rouge",
        description: "Côte Brune, syrah et viognier Guigal prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-017",
        name: "Hermitage La Chapelle Jaboulet 2016, 75cl",
        price: 285000,
        origin: "Rhône",
        tag: "Vin rouge",
        description: "Côte de l'Hermitage, syrah pure Jaboulet prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-018",
        name: "Côte-Rôtie La Turque Guigal 2018, 75cl",
        price: 245000,
        origin: "Rhône",
        tag: "Vin rouge",
        description: "Côte Brune prestige Guigal La Turque.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-019",
        name: "Châteauneuf-du-Pape Chapoutier La Bernardine 2019, 75cl",
        price: 65000,
        origin: "Rhône",
        tag: "Vin rouge",
        description: "Grenache et syrah du sud Chapoutier prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-020",
        name: "Clos de Vougeot Grand Cru 2018, 75cl",
        price: 185000,
        origin: "Bourgogne",
        tag: "Vin rouge",
        description: "Domaine Gros Frère & Sœur Clos de Vougeot prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-021",
        name: "Echezeaux Grand Cru 2018, 75cl",
        price: 215000,
        origin: "Bourgogne",
        tag: "Vin rouge",
        description: "Domaine d'Eugénie Echezeaux Grand Cru prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-022",
        name: "Richebourg Grand Cru 2018, 75cl",
        price: 425000,
        origin: "Bourgogne",
        tag: "Vin rouge",
        description: "Domaine de la Romanée-Conti Richebourg prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-023",
        name: "Chablis Grand Cru Les Clos 2020, 75cl",
        price: 32500,
        origin: "Bourgogne",
        tag: "Vin blanc",
        description: "Chardonnay minéral pur Chablis Grand Cru prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-024",
        name: "Meursault Pierre Morey 1er cru 2019, 75cl",
        price: 65000,
        origin: "Bourgogne",
        tag: "Vin blanc",
        description: "Chardonnay gras et beurré Meursault prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-025",
        name: "Gevrey-Chambertin 1er cru 2019, 75cl",
        price: 75000,
        origin: "Bourgogne",
        tag: "Vin rouge",
        description: "Pinot noir de la Côte de Nuits prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-026",
        name: "Pommard 1er cru Les Rugiens 2018, 75cl",
        price: 82000,
        origin: "Bourgogne",
        tag: "Vin rouge",
        description: "Pinot noir puissant Pommard 1er cru prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-027",
        name: "Sancerre Henri Bourgeois Les Baronnes 2021, 75cl",
        price: 18000,
        origin: "Loire",
        tag: "Vin blanc",
        description: "Sauvignon blanc minéral Sancerre prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-028",
        name: "Vouvray moelleux Huet 2018, 75cl",
        price: 32000,
        origin: "Loire",
        tag: "Vin blanc",
        description: "Chenin botrytisé de garde Huet prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-029",
        name: "Côtes de Provence rosé Domaines Ott 2022, 75cl",
        price: 28500,
        origin: "Provence",
        tag: "Vin rosé",
        description: "Cuvée Château de Selle Domaines Ott prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-030",
        name: "Champagne Salon 2012, 75cl",
        price: 425000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Côte des Blancs, chardonnay pur Salon prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-031",
        name: "Champagne Salon 2007, 75cl",
        price: 525000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Millésime prestige Salon Côte des Blancs.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-032",
        name: "Champagne Dom Pérignon 2013, 75cl",
        price: 85000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Cuvée prestige de Moët & Chandon prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-033",
        name: "Champagne Cristal Roederer 2015, 75cl",
        price: 105000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Cuvée iconique de Louis Roederer prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-034",
        name: "Champagne Krug Grande Cuvée, 75cl",
        price: 85000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Assemblage de plus de 120 vins Krug prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-035",
        name: "Champagne Krug Clos d'Ambonnay 2006, 75cl",
        price: 425000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Clos d'Ambonnay prestige Krug.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-036",
        name: "Champagne Bollinger La Grande Année 2014, 75cl",
        price: 62000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Pinot noir dominant Bollinger Grande Année prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-037",
        name: "Champagne Pol Roger Cuvée Sir Winston 2013, 75cl",
        price: 725000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Hommage à Churchill Pol Roger prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-038",
        name: "Champagne Jacques Selosse Initial, 75cl",
        price: 85000,
        origin: "Champagne",
        tag: "Champagne",
        description: "Côte des Blancs, vigneron d'exception Selosse prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-039",
        name: "Cognac Rémy Martin Louis XIII, 70cl",
        price: 2850000,
        origin: "Charente",
        tag: "Spiritueux",
        description: "Carafe prestige Baccarat Louis XIII prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-040",
        name: "Cognac Hennessy Paradis Imperial, 70cl",
        price: 525000,
        origin: "Charente",
        tag: "Spiritueux",
        description: "Assemblage prestige de 100 eaux-de-vie Hennessy prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-041",
        name: "Cognac Hennessy Paradis, 70cl",
        price: 385000,
        origin: "Charente",
        tag: "Spiritueux",
        description: "Assemblage prestige Hennessy Paradis.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-042",
        name: "Cognac Martell Cordon Bleu, 70cl",
        price: 75000,
        origin: "Charente",
        tag: "Spiritueux",
        description: "Cuvée historique Martell Cordon Bleu prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-043",
        name: "Armagnac Château de Laubade 1979, 70cl",
        price: 145000,
        origin: "Gers",
        tag: "Spiritueux",
        description: "Millésime bas-armagnac Château de Laubade prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-044",
        name: "Calvados Christian Drouin 1979, 70cl",
        price: 95000,
        origin: "Calvados",
        tag: "Spiritueux",
        description: "Calvados millésimé du pays d'Auge Drouin prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-045",
        name: "Whisky Macallan 25 ans Sherry Oak, 70cl",
        price: 1250000,
        origin: "Écosse",
        tag: "Spiritueux",
        description: "Single malt vieilli en fûts de xérès Macallan 25 ans prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-046",
        name: "Whisky Macallan 30 ans Sherry Oak, 70cl",
        price: 1850000,
        origin: "Écosse",
        tag: "Spiritueux",
        description: "Single malt prestige Macallan 30 ans prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-047",
        name: "Whisky Glenfiddich 30 ans, 70cl",
        price: 785000,
        origin: "Écosse",
        tag: "Spiritueux",
        description: "Single malt d'âge mûr Glenfiddich 30 ans prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-048",
        name: "Rhum Clément 1970, 70cl",
        price: 950000,
        origin: "Martinique",
        tag: "Spiritueux",
        description: "Rhum agricole millésimé Clément 1970 prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-049",
        name: "Rhum Depaz 2002, 70cl",
        price: 105000,
        origin: "Martinique",
        tag: "Spiritueux",
        description: "Rhum agricole de la montagne Pelée Depaz 2002 prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
      {
        id: "cave-exception-050",
        name: "Porto Vintage Fonseca 2017, 75cl",
        price: 38500,
        origin: "Portugal",
        tag: "Vin doux",
        description: "Porto vintage millésimé Fonseca 2017 prestige.",
        boutiqueId: "cave-exception",
        boutiqueName: "Cave d'Exception",
      },
    ],
  },
  {
    id: "bazar-deco",
    name: "Bazar & Déco",
    subtitle: "Art de la Maison Premium",
    countLabel: "3000 articles prestige",
    tagline: "L'art de la maison au quotidien",
    icon: "⌂",
    accent: "#a8835b",
    description: "Trois mille articles pour la maison et le quotidien : ustensiles de cuisine de chef, vaisselle en porcelaine, petits électroménagers, arts de la table, décoration, droguerie et bazar. Des marques de qualité : Le Creuset, Staub, KitchenAid, Christofle, Baccarat, Lalique, et l'artisanat français d'exception.",
    products: [
      {
        id: "bazar-deco-001",
        name: "Cocotte en fonte Le Creuset 24cm signature orange",
        price: 125000,
        origin: "France",
        tag: "Cuisine",
        description: "Cocotte en fonte émaillée Le Creuset 24cm signature prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-002",
        name: "Cocotte en fonte Staub 24cm signature noire",
        price: 115000,
        origin: "Alsace",
        tag: "Cuisine",
        description: "Cocotte en fonte Staub 24cm noire mate prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-003",
        name: "Cocotte en fonte Le Creuset 30cm signature",
        price: 165000,
        origin: "France",
        tag: "Cuisine",
        description: "Cocotte Le Creuset 30cm signature prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-004",
        name: "Robot pâtissier KitchenAid Artisan 4.8L gris platinum",
        price: 425000,
        origin: "États-Unis",
        tag: "Électroménager",
        description: "Robot pâtissier KitchenAid Artisan 4.8L prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-005",
        name: "Robot pâtissier KitchenAid 7L Pro Line série",
        price: 685000,
        origin: "États-Unis",
        tag: "Électroménager",
        description: "Robot KitchenAid Pro Line 7L prestige premium.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-006",
        name: "Batteur plongeant Bamix Gastro Pro 3 200W",
        price: 95000,
        origin: "Suisse",
        tag: "Électroménager",
        description: "Mixeur plongeant Bamix Gastro Pro 3 suisse prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-007",
        name: "Bouilloire électrique Smeg 1.7L rétro crème",
        price: 75000,
        origin: "Italie",
        tag: "Électroménager",
        description: "Bouilloire Smeg 1.7L rétro prestige italienne.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-008",
        name: "Grille-pain Smeg 2 tranches rétro crème",
        price: 68000,
        origin: "Italie",
        tag: "Électroménager",
        description: "Grille-pain Smeg 2 tranches rétro prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-009",
        name: "Machine à café Nespresso Creatista Plus",
        price: 285000,
        origin: "Suisse",
        tag: "Électroménager",
        description: "Machine Nespresso Creatista Plus prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-010",
        name: "Machine à café Jura Z10 écran tactile",
        price: 1450000,
        origin: "Suisse",
        tag: "Électroménager",
        description: "Machine à café Jura Z10 prestige suisse.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-011",
        name: "Machine à café De'Longhi Maestosa",
        price: 1850000,
        origin: "Italie",
        tag: "Électroménager",
        description: "Machine à café De'Longhi Maestosa prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-012",
        name: "Théière Breville One-Touch Tea Maker",
        price: 145000,
        origin: "Australie",
        tag: "Électroménager",
        description: "Théière One-Touch Breville prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-013",
        name: "Couteau de chef Global G-2 20cm premium",
        price: 55000,
        origin: "Japon",
        tag: "Ustensile",
        description: "Couteau de chef Global G-2 20cm japonais prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-014",
        name: "Set 6 couteaux Wüsthof Classic Ikon en bloc",
        price: 285000,
        origin: "Allemagne",
        tag: "Ustensile",
        description: "Set 6 couteaux Wüsthof Classic Ikon prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-015",
        name: "Couteau à pain Laguiole Aubrac forgé main",
        price: 42000,
        origin: "Aveyron",
        tag: "Ustensile",
        description: "Couteau à pain Laguiole Aubrac forgé main prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-016",
        name: "Couteau de chef Shun Premier 20cm",
        price: 95000,
        origin: "Japon",
        tag: "Ustensile",
        description: "Couteau de chef Shun Premier japonais prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-017",
        name: "Planche à découper en olivier massif 50x30",
        price: 28000,
        origin: "Provence",
        tag: "Ustensile",
        description: "Planche à découper en olivier massif Provence prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-018",
        name: "Mortier en marbre blanc italien 22cm",
        price: 32000,
        origin: "Italie",
        tag: "Ustensile",
        description: "Mortier en marbre blanc italien 22cm prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-019",
        name: "Wok en fonte Lodge 35cm premium",
        price: 55000,
        origin: "États-Unis",
        tag: "Ustensile",
        description: "Wok en fonte Lodge 35cm pré-assaisonné prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-020",
        name: "Marmite en cuivre Baumalu 24cm premium",
        price: 65000,
        origin: "Alsace",
        tag: "Ustensile",
        description: "Marmite en cuivre étamé Baumalu 24cm prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-021",
        name: "Bouilloire en cuivre étamé Mauviel 1.5L",
        price: 55000,
        origin: "Normandie",
        tag: "Ustensile",
        description: "Bouilloire en cuivre étamé Mauviel prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-022",
        name: "Poêle Mauviel M'150S cuivre 28cm premium",
        price: 95000,
        origin: "Normandie",
        tag: "Ustensile",
        description: "Poêle en cuivre Mauviel M'150S 28cm prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-023",
        name: "Saladier en bois d'olivier massif 40cm",
        price: 28000,
        origin: "Provence",
        tag: "Ustensile",
        description: "Saladier en bois d'olivier massif 40cm prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-024",
        name: "Set 4 ramequins en porcelaine Le Creuset prestige",
        price: 28000,
        origin: "France",
        tag: "Vaisselle",
        description: "Set 4 ramequins en porcelaine Le Creuset prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-025",
        name: "Set 12 couverts en inox Christofle Mood premium",
        price: 145000,
        origin: "Paris",
        tag: "Argenterie",
        description: "Set 12 couverts Christofle Mood inox prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-026",
        name: "Set 12 couverts Christofle Concorde argent massif",
        price: 425000,
        origin: "Paris",
        tag: "Argenterie",
        description: "Set 12 couverts Christofle Concorde prestige argent.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-027",
        name: "Carafe en cristal Baccarat 1L prestige",
        price: 145000,
        origin: "Meurthe-et-Moselle",
        tag: "Verrerie",
        description: "Carafe en cristal Baccarat 1L prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-028",
        name: "Verres à whisky Baccarat set de 4",
        price: 85000,
        origin: "Meurthe-et-Moselle",
        tag: "Verrerie",
        description: "Verres à whisky Baccarat cristal prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-029",
        name: "Verres à vin dégustation Riedel Sommelier set de 6",
        price: 55000,
        origin: "Autriche",
        tag: "Verrerie",
        description: "Set 6 verres à vin dégustation Riedel prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-030",
        name: "Théière en fonte japonaise Tetsubin 1L prestige",
        price: 55000,
        origin: "Japon",
        tag: "Vaisselle",
        description: "Théière en fonte japonaise Tetsubin 1L prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-031",
        name: "Assiettes plates en porcelaine Bernardaud Louvre set de 6",
        price: 75000,
        origin: "Limousin",
        tag: "Vaisselle",
        description: "Assiettes plates Bernardaud Louvre set de 6 prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-032",
        name: "Assiettes Hermès Mosaique au 24 set de 6",
        price: 285000,
        origin: "Paris",
        tag: "Porcelaine",
        description: "Assiettes Hermès Mosaique set de 6 prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-033",
        name: "Set 4 tasses à café en porcelaine Raynaud",
        price: 28500,
        origin: "Limousin",
        tag: "Vaisselle",
        description: "Set 4 tasses à café Raynaud porcelaine prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-034",
        name: "Bougie parfumée Cire Trudon Ernesto 800g prestige",
        price: 62000,
        origin: "Paris",
        tag: "Bougie",
        description: "Bougie parfumée Cire Trudon Ernesto 800g prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-035",
        name: "Bougie parfumée Diptyque Baies 600g prestige",
        price: 48000,
        origin: "Paris",
        tag: "Bougie",
        description: "Bougie parfumée Diptyque Baies 600g prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-036",
        name: "Vase en verre soufflé Murano 40cm prestige",
        price: 125000,
        origin: "Italie",
        tag: "Décoration",
        description: "Vase en verre soufflé Murano 40cm prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-037",
        name: "Vase Lalique Tourbillon 28cm prestige",
        price: 285000,
        origin: "Moselle",
        tag: "Décoration",
        description: "Cristal moulé main motif tourbillon Lalique prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-038",
        name: "Vase Baccarat Albe 30cm prestige",
        price: 225000,
        origin: "Meurthe-et-Moselle",
        tag: "Décoration",
        description: "Cristal taillé Baccarat Albe prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-039",
        name: "Miroir solaire doré Baccarat 80cm prestige",
        price: 245000,
        origin: "France",
        tag: "Décoration",
        description: "Miroir soleil doré à la feuille prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-040",
        name: "Tapis Berbère Beni Ouarain 2x3m laine vierge",
        price: 425000,
        origin: "Maroc",
        tag: "Décoration",
        description: "Tapis Berbère Beni Ouarain 2x3m laine vierge prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-041",
        name: "Plaid en laine vierge Pierre Frey prestige",
        price: 55000,
        origin: "Paris",
        tag: "Décoration",
        description: "Plaid en laine vierge Pierre Frey prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-042",
        name: "Coussin en lin lavé Le Jacquard Français prestige",
        price: 14500,
        origin: "Vosges",
        tag: "Décoration",
        description: "Coussin en lin lavé Le Jacquard Français prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-043",
        name: "Parure de lit Le Jacquard Français Vence 240x220",
        price: 145000,
        origin: "Vosges",
        tag: "Linge",
        description: "Parure de lit Le Jacquard Français Vence prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-044",
        name: "Serviettes de bain Abyss & Habidek 70x140",
        price: 42500,
        origin: "Belgique",
        tag: "Linge",
        description: "Serviettes de bain Abyss & Habidek 70x140 prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-045",
        name: "Peignoir Abyss & Habidek coton égyptien",
        price: 95000,
        origin: "Belgique",
        tag: "Linge",
        description: "Peignoir Abyss & Habidek coton égyptien prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-046",
        name: "Aspirateur balai Dyson V15 Detect Absolute",
        price: 245000,
        origin: "Royaume-Uni",
        tag: "Électroménager",
        description: "Aspirateur balai Dyson V15 Detect Absolute prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-047",
        name: "Centrale vapeur Philips PerfectCare Elite Plus",
        price: 185000,
        origin: "Pays-Bas",
        tag: "Électroménager",
        description: "Centrale vapeur Philips PerfectCare Elite Plus prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-048",
        name: "Cadre argenté Christofle 13x18 prestige",
        price: 95000,
        origin: "Paris",
        tag: "Décoration",
        description: "Cadre photo argent massif Christofle prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-049",
        name: "Carafe décanter Riedel Swan prestige",
        price: 65000,
        origin: "Autriche",
        tag: "Verrerie",
        description: "Carafe décanter Riedel Swan prestige cristal.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
      {
        id: "bazar-deco-050",
        name: "Saladier en cristal Lalique Pompone prestige",
        price: 145000,
        origin: "Moselle",
        tag: "Verrerie",
        description: "Saladier en cristal Lalique Pompone prestige.",
        boutiqueId: "bazar-deco",
        boutiqueName: "Bazar & Déco",
      },
    ],
  },
  {
    id: "pharmacie",
    name: "Pharmacie",
    subtitle: "Conseil pharmacien prestige",
    countLabel: "Conseil pharmacien prestige",
    tagline: "Le conseil pharmacien à votre écoute",
    icon: "✛",
    accent: "#6e8a7d",
    description: "Pharmacie d'exception avec conseil personnalisé : dermo-cosmétique de prestige, compléments alimentaires premium, huiles essentielles rares, soins de marques dermo-pharmaceutiques, et matériel médical de qualité. Notre pharmacien diplômé est à votre écoute 7j/7.",
    products: [
      {
        id: "pharmacie-001",
        name: "Crème La Mer The Concentrate 50ml prestige",
        price: 285000,
        origin: "États-Unis",
        tag: "Soin visage",
        description: "Concentré Miracle Broth La Mer prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-002",
        name: "Crème La Prairie Skin Caviar 50ml prestige",
        price: 545000,
        origin: "Suisse",
        tag: "Soin visage",
        description: "Crème caviar liftant La Prairie prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-003",
        name: "Sérum La Prairie Skin Caviar 30ml prestige",
        price: 425000,
        origin: "Suisse",
        tag: "Soin visage",
        description: "Sérum caviar La Prairie prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-004",
        name: "Crème Sisleya Global Anti-Age 50ml prestige",
        price: 245000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Crème anti-âge Sisley Sisleya prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-005",
        name: "Sérum Sisleya L'Intégral Anti-Âge 30ml prestige",
        price: 215000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Sérum anti-âge Sisley prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-006",
        name: "Crème Chanel Sublimage La Crème 50ml prestige",
        price: 185000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Extrait de vanille de Madagascar Chanel prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-007",
        name: "Sérum Chanel Sublimage L'Extrait Intensité 30ml prestige",
        price: 195000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Sérum Chanel Sublimage prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-008",
        name: "Crème Lancôme Absolue Premium 60ml prestige",
        price: 125000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Crème à la rose Lancôme Absolue prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-009",
        name: "Sérum Lancôme Absolue L'Extrait 30ml prestige",
        price: 145000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Sérum absolu Lancôme prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-010",
        name: "Sérum Estée Lauder Advanced Night Repair 50ml prestige",
        price: 55000,
        origin: "États-Unis",
        tag: "Soin visage",
        description: "Sérum de nuit historique Estée Lauder prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-011",
        name: "Sérum Estée Lauder Re-Nutriv Ultimate Lift 50ml prestige",
        price: 185000,
        origin: "États-Unis",
        tag: "Soin visage",
        description: "Sérum prestige Re-Nutriv Estée Lauder.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-012",
        name: "Crème Estée Lauder Re-Nutriv Ultimate Diamond 50ml prestige",
        price: 215000,
        origin: "États-Unis",
        tag: "Soin visage",
        description: "Crème prestige Re-Nutriv Ultimate Diamond.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-013",
        name: "Crème Guerlain Orchidée Impériale 50ml prestige",
        price: 165000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Extrait d'orchidée noire Guerlain prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-014",
        name: "Sérum Guerlain Orchidée Impériale 30ml prestige",
        price: 185000,
        origin: "Paris",
        tag: "Soin visage",
        description: "Sérum prestige orchidée noire Guerlain.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-015",
        name: "Sérum Vichy Liftactiv Supreme 30ml prestige",
        price: 28000,
        origin: "France",
        tag: "Soin visage",
        description: "Sérum anti-âge Vichy Liftactiv prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-016",
        name: "Crème Vichy Liftactiv Supreme Nuit 50ml prestige",
        price: 32000,
        origin: "France",
        tag: "Soin visage",
        description: "Crème nuit Vichy Liftactiv prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-017",
        name: "Crème La Roche-Posay Toleriane Dermallergo 50ml prestige",
        price: 18500,
        origin: "France",
        tag: "Soin visage",
        description: "Crème La Roche-Posay prestige Toleriane.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-018",
        name: "Sérum La Roche-Posay Hyalu B5 30ml prestige",
        price: 22500,
        origin: "France",
        tag: "Soin visage",
        description: "Sérum La Roche-Posay Hyalu B5 prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-019",
        name: "Crème Avène RetrinAL 30ml prestige",
        price: 22500,
        origin: "France",
        tag: "Soin visage",
        description: "Crème Avène RetrinAL prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-020",
        name: "Crème Nuxe Rêve de Miel 50ml prestige",
        price: 18500,
        origin: "France",
        tag: "Soin visage",
        description: "Crème Nuxe Rêve de Miel prestige visage.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-021",
        name: "Huile Nuxe Multi Usage Prodigieuse 100ml prestige",
        price: 22500,
        origin: "France",
        tag: "Soin corps",
        description: "Huile multi-usage Nuxe Prodigieuse prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-022",
        name: "Complément Pierre Cardin Beauté Marine Collagène 30j",
        price: 42500,
        origin: "France",
        tag: "Complément",
        description: "Cure luxe marine collagène Pierre Cardin prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-023",
        name: "Complément Therascience Collagène 21 jours prestige",
        price: 42500,
        origin: "France",
        tag: "Complément",
        description: "Collagène pur Peptan bioactif Therascience prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-024",
        name: "Complément Oemine Q10 Marine 60 gélules prestige",
        price: 22500,
        origin: "France",
        tag: "Complément",
        description: "Coenzyme Q10 anti-âge Oemine Q10 Marine prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-025",
        name: "Complément Oemine D3 vegan 2000UI 60 gélules prestige",
        price: 12500,
        origin: "France",
        tag: "Complément",
        description: "Vitamine D3 végétale lichen Oemine D3 prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-026",
        name: "Complément Puressentiel Magnésium Marin 60 gélules",
        price: 9500,
        origin: "France",
        tag: "Complément",
        description: "Magnésium marin + vitamine B6 Puressentiel prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-027",
        name: "Complément Solgar Oméga-3 EPA DHA 60 gélules prestige",
        price: 22500,
        origin: "États-Unis",
        tag: "Complément",
        description: "Huile de poisson purifiée Solgar Oméga-3 prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-028",
        name: "Complément Solgar Skin Nails Hair 60 comprimés prestige",
        price: 14500,
        origin: "États-Unis",
        tag: "Complément",
        description: "Soufre MSM rouge Solgar Skin Nails Hair prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-029",
        name: "Complément Nutergia Ergyphilat Plus 60 gélules prestige",
        price: 24500,
        origin: "France",
        tag: "Complément",
        description: "Levure et ferments intestinaux Nutergia prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-030",
        name: "Complément Nutergia Ergymunyl 60 gélules prestige",
        price: 19500,
        origin: "France",
        tag: "Complément",
        description: "Immunité sélénium zinc Nutergia Ergymunyl prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-031",
        name: "Huile essentielle Rose de Damas 2ml prestige",
        price: 38000,
        origin: "Bulgarie",
        tag: "Aromathérapie",
        description: "Rosa damascena pure Rose de Damas prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-032",
        name: "Huile essentielle Jasmin grandiflorum 2ml prestige",
        price: 32000,
        origin: "Inde",
        tag: "Aromathérapie",
        description: "Jasmin grandiflorum prestige Inde.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-033",
        name: "Huile essentielle Nérooli bigarade 5ml prestige",
        price: 28000,
        origin: "Tunisie",
        tag: "Aromathérapie",
        description: "Nérooli bigarade prestige Tunisie.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-034",
        name: "Huile essentielle Lavande vraie AOP 10ml prestige",
        price: 6500,
        origin: "France",
        tag: "Aromathérapie",
        description: "Lavandula angustifolia AOP lavande vraie prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-035",
        name: "Huile essentielle Ravintsara 10ml prestige",
        price: 5500,
        origin: "Madagascar",
        tag: "Aromathérapie",
        description: "Cinnamomum camphora ct cinéole Ravintsara prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-036",
        name: "Diffuseur Pranarôm Nebulisation bois premium",
        price: 45000,
        origin: "France",
        tag: "Aromathérapie",
        description: "Diffuseur par nébulisation froide Pranarôm prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-037",
        name: "Diffuseur Neom Luxury Organics prestige",
        price: 85000,
        origin: "Royaume-Uni",
        tag: "Aromathérapie",
        description: "Diffuseur prestige Neom Luxury Organics.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-038",
        name: "Roll-on Puressentiel anti-moustique tropical 5ml prestige",
        price: 4500,
        origin: "France",
        tag: "Aromathérapie",
        description: "Protection tropicale 7 HE Puressentiel prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-039",
        name: "Baume Tiger Balm Blanc 30g prestige",
        price: 4500,
        origin: "Thaïlande",
        tag: "Aromathérapie",
        description: "Baume mentholé traditionnel Tiger Balm prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-040",
        name: "Tensiomètre bras Omron M7 Intelli IT prestige",
        price: 55000,
        origin: "Japon",
        tag: "Médical",
        description: "Tensiomètre bras Omron M7 Intelli IT prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-041",
        name: "Tensiomètre poignet Omron RS7 Intelli IT prestige",
        price: 45000,
        origin: "Japon",
        tag: "Médical",
        description: "Tensiomètre poignet Omron RS7 Intelli IT prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-042",
        name: "Thermomètre digital Omron premium prestige",
        price: 9500,
        origin: "Japon",
        tag: "Médical",
        description: "Thermomètre digital Omron flexible prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-043",
        name: "Glucomètre Accu-Chek Instant prestige",
        price: 18500,
        origin: "Suisse",
        tag: "Médical",
        description: "Glucomètre Accu-Chek Instant prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-044",
        name: "Oxymètre de pouls Beurer PO80 prestige",
        price: 18500,
        origin: "Allemagne",
        tag: "Médical",
        description: "Oxymètre de pouls Beurer PO80 prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-045",
        name: "Pansements mixtes Urgo 40 pièces prestige",
        price: 5500,
        origin: "France",
        tag: "Premiers secours",
        description: "Pansements mixtes Urgo 40 pièces prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-046",
        name: "Crème Biafine 100g prestige",
        price: 5500,
        origin: "France",
        tag: "Pharmacie",
        description: "Crème cicatrisante Biafine 100g prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-047",
        name: "Crème Cicaplast Baume B5 La Roche-Posay 100ml prestige",
        price: 12500,
        origin: "France",
        tag: "Pharmacie",
        description: "Crème Cicaplast Baume B5 La Roche-Posay prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-048",
        name: "Crème Homéoplasmine Boiron 43g prestige",
        price: 9500,
        origin: "France",
        tag: "Pharmacie",
        description: "Crème Homéoplasmine Boiron 43g prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-049",
        name: "Complément Forever Arctic Sea 120 gélules prestige",
        price: 22500,
        origin: "États-Unis",
        tag: "Complément",
        description: "Oméga-3 calamar et poisson Forever Arctic prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
      {
        id: "pharmacie-050",
        name: "Complément Forever Bee Pollen 100 comprimés prestige",
        price: 14500,
        origin: "États-Unis",
        tag: "Complément",
        description: "Pollen d'abeille pur Forever Bee Pollen prestige.",
        boutiqueId: "pharmacie",
        boutiqueName: "Pharmacie",
      },
    ],
  },
  {
    id: "boulangerie-royale",
    name: "La Boulangerie Royale",
    subtitle: "Pains & Pâtisseries d'Exception",
    countLabel: "50 produits prestige",
    tagline: "Le savoir-faire du boulanger",
    icon: "✸",
    accent: "#b8853b",
    description: "Pains, pâtisseries et viennoiseries d'exception, préparés chaque nuit par notre chef boulanger. Levain naturel 24h, farines T65 et T80 de blés français, beurre AOP Charentes-Poitou. De la baguette de tradition à la pâtisserie fine, l'art du boulanger sublimé.",
    products: [
      {
        id: "boulangerie-royale-001",
        name: "Baguette de tradition française premium",
        price: 1500,
        origin: "Paris",
        tag: "Pain",
        description: "Baguette pur blé T65 croûte fine premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-002",
        name: "Baguette de campagne au levain 24h premium",
        price: 2200,
        origin: "Paris",
        tag: "Pain",
        description: "Baguette levain naturel 24h premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-003",
        name: "Baguette aux 5 céréales premium",
        price: 2400,
        origin: "Paris",
        tag: "Pain",
        description: "Blé seigle orge avoine lin premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-004",
        name: "Baguette aux graines premium",
        price: 2600,
        origin: "Paris",
        tag: "Pain",
        description: "Sésame pavot lin tournesol premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-005",
        name: "Pain de campagne au levain 1kg premium",
        price: 8500,
        origin: "Paris",
        tag: "Pain",
        description: "Pain rustique au levain naturel premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-006",
        name: "Pain au levain de seigre 1kg premium",
        price: 9500,
        origin: "Paris",
        tag: "Pain",
        description: "Levain de seigle fermentation 24h premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-007",
        name: "Pain de seigle rustique 1.2kg premium",
        price: 10500,
        origin: "Paris",
        tag: "Pain",
        description: "Pain de seigle rustique traditionnel premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-008",
        name: "Pain complet intégral T150 800g premium",
        price: 6500,
        origin: "Paris",
        tag: "Pain",
        description: "Farine complète T150 son premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-009",
        name: "Pain aux noix de Grenoble 600g premium",
        price: 7500,
        origin: "Paris",
        tag: "Pain",
        description: "Pain aux noix fraîches de Grenoble premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-010",
        name: "Pain aux figues de Solliès AOP 600g premium",
        price: 8500,
        origin: "Paris",
        tag: "Pain",
        description: "Pain aux figues de Solliès AOP premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-011",
        name: "Pain aux olives noires Nyons AOP 600g premium",
        price: 7800,
        origin: "Paris",
        tag: "Pain",
        description: "Olives noires Nyons AOP premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-012",
        name: "Tourte de seigle de Countrai 1kg premium",
        price: 9500,
        origin: "Nord",
        tag: "Pain",
        description: "Pain de seigle dense de Flandre premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-013",
        name: "Pain à l'ancienne au levain 1.5kg premium",
        price: 12500,
        origin: "Paris",
        tag: "Pain",
        description: "Pain à l'ancienne au levain de seigle premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-014",
        name: "Pain miche de campagne au feu de bois 2kg premium",
        price: 16500,
        origin: "Île-de-France",
        tag: "Pain",
        description: "Cuit au feu de bois, levain naturel 24h premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-015",
        name: "Pain de mie tranché 500g premium",
        price: 5500,
        origin: "Paris",
        tag: "Pain",
        description: "Pain de mie sans huile de palme premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-016",
        name: "Brioche tressée maison 500g premium",
        price: 8500,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Brioche tressée beurre AOP Charentes premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-017",
        name: "Brioche au sucre perlé 500g premium",
        price: 8800,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Brioche sugaire T55 sucre perlé premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-018",
        name: "Brioche Nanterre pur beurre 500g premium",
        price: 8500,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Brioche Nanterre beurre AOP Charentes premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-019",
        name: "Pain au lait pur beurre pièce premium",
        price: 1800,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Pain au lait beurre Charentes premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-020",
        name: "Croissant pur beurre AOP pièce premium",
        price: 1800,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Croissant beurre AOP Charentes premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-021",
        name: "Croissant aux amandes pièce premium",
        price: 2400,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Croissant fourré crème amande premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-022",
        name: "Pain au chocolat pur beurre premium",
        price: 1800,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Pain au chocolat deux barres Valrhona premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-023",
        name: "Chausson aux pommes premium",
        price: 2400,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Chausson pommes Reinettes du Vaucluse premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-024",
        name: "Brioche feuilletée pralines roses premium",
        price: 5200,
        origin: "Paris",
        tag: "Viennoiserie",
        description: "Brioche pralines roses de Briollay premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-025",
        name: "Kouign-amann au beurre demi-sel AOP premium",
        price: 3800,
        origin: "Bretagne",
        tag: "Viennoiserie",
        description: "Spécialité bretonne feuilletée beurre AOP premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-026",
        name: "Far Breton aux pruneaux d'Agen premium",
        price: 5200,
        origin: "Bretagne",
        tag: "Pâtisserie",
        description: "Far pruneaux d'Agen premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-027",
        name: "Flan pâtissier traditionnel à la vanille premium",
        price: 4800,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Flan pâte brisée crème pâtissière premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-028",
        name: "Flan parisien à la vanille Bourbon Madagascar premium",
        price: 5200,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Flan vanille Bourbon Madagascar premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-029",
        name: "Tarte aux pommes Reinette grise premium",
        price: 5500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Tarte pommes Reinette grise premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-030",
        name: "Tarte aux fraises Plougastel premium",
        price: 7800,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Tarte fraises Plougastel crème pâtissière premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-031",
        name: "Tarte au citron meringué de Menton premium",
        price: 6500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Citron de Menton AOP meringue italienne premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-032",
        name: "Paris-Brest individuel praline premium",
        price: 7500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Pâte à choux crème pralinée noisettes premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-033",
        name: "Éclair café Arabica prestige",
        price: 5200,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Pâte à choux crème café Arabica premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-034",
        name: "Éclair chocolat Valrhona 70% prestige",
        price: 5200,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Pâte à choux crème chocolat Valrhona premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-035",
        name: "Mille-feuille vanille Bourbon Madagascar prestige",
        price: 7500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Pâte feuilletée crème vanille Bourbon premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-036",
        name: "Saint-Honoré individuel caramel beurre salé prestige",
        price: 8500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Pâte à choux caramel beurre salé premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-037",
        name: "Opéra tradition grand cru prestige",
        price: 7500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Biscuit Joconde café ganache chocolat premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-038",
        name: "Tarte tropézienne prestige",
        price: 7200,
        origin: "Provence",
        tag: "Pâtisserie",
        description: "Brioche à la crème pâtissière premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-039",
        name: "Tarte Tatin aux pommes Royal Gala prestige",
        price: 6500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Pommes caramélisées sur tarte renversée premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-040",
        name: "Cannelé de Bordeaux premium pièce",
        price: 2800,
        origin: "Bordeaux",
        tag: "Pâtisserie",
        description: "Cannelé rhum vanille Bordeaux premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-041",
        name: "Macaron Ladurée framboise pièce premium",
        price: 2200,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Macaron Ladurée framboise pâte d'amande premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-042",
        name: "Macaron Ladurée pistache de Sicile pièce premium",
        price: 2400,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Macaron Ladurée pistache de Sicile premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-043",
        name: "Macaron Ladurée chocolat Valrhona pièce premium",
        price: 2200,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Macaron Ladurée chocolat Valrhona 70% premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-044",
        name: "Coffret 12 macarons Ladurée assortis prestige",
        price: 28000,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Coffret de macarons Ladurée assortis premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-045",
        name: "Coffret 24 macarons Ladurée assortis prestige",
        price: 52000,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Coffret de macarons Ladurée assortis luxe premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-046",
        name: "Sablé normand au beurre AOP Isigny 200g premium",
        price: 8500,
        origin: "Normandie",
        tag: "Biscuit",
        description: "Sablé beurre AOP Isigny premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-047",
        name: "Madeleine de Commercy 12 pièces premium",
        price: 9500,
        origin: "Lorraine",
        tag: "Biscuit",
        description: "Madeleine coque au beurre noisette premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-048",
        name: "Pain d'épices au miel de Provence 500g premium",
        price: 8500,
        origin: "Provence",
        tag: "Pâtisserie",
        description: "Pain d'épices miel de Provence premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-049",
        name: "Galette des rois frangipane prestige (saison)",
        price: 12500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Galette frangipane et fève premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
      {
        id: "boulangerie-royale-050",
        name: "Bûche de Noël chocolat Valrhona prestige (saison)",
        price: 28500,
        origin: "Paris",
        tag: "Pâtisserie",
        description: "Bûche de Noël chocolat noir Valrhona premium.",
        boutiqueId: "boulangerie-royale",
        boutiqueName: "La Boulangerie Royale",
      },
    ],
  },
  {
    id: "comptoir-cafes",
    name: "Le Comptoir des Cafés",
    subtitle: "Cafés, Thés & Cacao Grand Cru",
    countLabel: "50 produits prestige",
    tagline: "Le rituel des grands crus",
    icon: "✤",
    accent: "#5d4a3b",
    description: "Cafés, thés et cacaos d'exception, sélectionnés par notre maître torréfacteur et notre théier en chef. Cafés Blue Mountain, Kopi Luwak et Yirgacheffe ; thés Darjeeling, Matcha et Pu-erh millésimé ; cacaos grand cru Valrhona. Le rituel des grands crus, à la tasse comme en grains.",
    products: [
      {
        id: "comptoir-cafes-001",
        name: "Café Blue Mountain Jamaïque Wallenford Estate 250g",
        price: 38500,
        origin: "Jamaïque",
        tag: "Café",
        description: "Café arabica Blue Mountain Wallenford Estate prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-002",
        name: "Café Blue Mountain Jamaïque 250g prestige",
        price: 29000,
        origin: "Jamaïque",
        tag: "Café",
        description: "Café arabica le plus rare du monde Blue Mountain prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-003",
        name: "Café Kopi Luwak Indonésie 100g prestige",
        price: 95000,
        origin: "Indonésie",
        tag: "Café",
        description: "Café civette récolté en forêt Kopi Luwak prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-004",
        name: "Café Geisha Esmeralda Panama 250g prestige",
        price: 32000,
        origin: "Panama",
        tag: "Café",
        description: "Lauréat Best of Panama Esmeralda Geisha prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-005",
        name: "Café Kona Hawaï 250g prestige",
        price: 26000,
        origin: "Hawaï",
        tag: "Café",
        description: "Arabica cultivé sur les volcans Kona Hawaï prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-006",
        name: "Café Bourbon Pointu Réunion 250g prestige",
        price: 22500,
        origin: "La Réunion",
        tag: "Café",
        description: "Variété rare à faible caféine Bourbon Pointu prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-007",
        name: "Café Moka Yémen 250g prestige",
        price: 18500,
        origin: "Yémen",
        tag: "Café",
        description: "Arabica historique de Moka Yémen prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-008",
        name: "Café Yirgacheffe Éthiopie 250g prestige",
        price: 12500,
        origin: "Éthiopie",
        tag: "Café",
        description: "Arabica aux notes florales de jasmin Yirgacheffe prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-009",
        name: "Café Sidamo Éthiopie 250g prestige",
        price: 11500,
        origin: "Éthiopie",
        tag: "Café",
        description: "Notes fruitées de petits fruits rouges Sidamo prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-010",
        name: "Café Sulawesi Toraja 250g prestige",
        price: 14500,
        origin: "Indonésie",
        tag: "Café",
        description: "Arabica rinse de bouche Sulawesi prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-011",
        name: "Café Sumatra Mandheling 250g prestige",
        price: 12500,
        origin: "Indonésie",
        tag: "Café",
        description: "Robe épaisse, notes de cèdre Sumatra prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-012",
        name: "Café Java Indonésie 250g prestige",
        price: 12500,
        origin: "Indonésie",
        tag: "Café",
        description: "Arabica ancien de l'île de Java prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-013",
        name: "Café Panama Esmeralda Geisha 250g prestige",
        price: 38500,
        origin: "Panama",
        tag: "Café",
        description: "Café Geisha lauréat Best of Panama prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-014",
        name: "Café Kenya AA 250g prestige",
        price: 14500,
        origin: "Kenya",
        tag: "Café",
        description: "Arabica vif notes de cassis Kenya AA prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-015",
        name: "Café Malabar Moussoné 250g prestige",
        price: 12500,
        origin: "Inde",
        tag: "Café",
        description: "Arabica moussoné notes épicées Malabar prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-016",
        name: "Café Guatemala Antigua 250g prestige",
        price: 12500,
        origin: "Guatemala",
        tag: "Café",
        description: "Arabica volcanique cacao Guatemala Antigua prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-017",
        name: "Café Costa Rica Tarrazú 250g prestige",
        price: 12500,
        origin: "Costa Rica",
        tag: "Café",
        description: "Arabica acidulé citronné Tarrazú prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-018",
        name: "Café Colombia Supremo 250g prestige",
        price: 11500,
        origin: "Colombie",
        tag: "Café",
        description: "Arabica équilibré chocolaté Colombia Supremo prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-019",
        name: "Café Saint-Domingue 250g prestige",
        price: 14500,
        origin: "Haïti",
        tag: "Café",
        description: "Arabica des Caraïbes doux Saint-Domingue prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-020",
        name: "Café Jamaica High Mountain 250g prestige",
        price: 18500,
        origin: "Jamaïque",
        tag: "Café",
        description: "Café de montagne second cru Jamaica prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-021",
        name: "Café Ethiopia Yirgacheffe Konga 250g prestige",
        price: 18500,
        origin: "Éthiopie",
        tag: "Café",
        description: "Yirgacheffe Konga micro-lot prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-022",
        name: "Café Brazil Sul de Minas 250g prestige",
        price: 9500,
        origin: "Brésil",
        tag: "Café",
        description: "Arabica doux noisette Sul de Minas prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-023",
        name: "Thé Darjeeling First Flush Margareth's Hope 100g prestige",
        price: 18500,
        origin: "Inde",
        tag: "Thé",
        description: "Première récolte printanière Darjeeling prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-024",
        name: "Thé Darjeeling Second Flush Castleton 100g prestige",
        price: 19500,
        origin: "Inde",
        tag: "Thé",
        description: "Récolte d'été muscatel Castleton prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-025",
        name: "Thé Darjeeling Autumnal Sungma 100g prestige",
        price: 16500,
        origin: "Inde",
        tag: "Thé",
        description: "Récolte d'automne ronde Sungma Darjeeling prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-026",
        name: "Thé Assam Mangalam FTGFOP1 100g prestige",
        price: 9500,
        origin: "Inde",
        tag: "Thé",
        description: "Thé noir malté robuste Assam Mangalam prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-027",
        name: "Thé Ceylan UVA High Grown 100g prestige",
        price: 9500,
        origin: "Sri Lanka",
        tag: "Thé",
        description: "Thé noir parfumé de l'Est Ceylan UVA prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-028",
        name: "Thé Earl Grey Mariage Frères Marco Polo 100g prestige",
        price: 18500,
        origin: "France",
        tag: "Thé",
        description: "Mélange Marco Polo bleu noir Mariage Frères prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-029",
        name: "Thé Marco Polo Bleu Mariage Frères 100g prestige",
        price: 19500,
        origin: "France",
        tag: "Thé",
        description: "Mélange secret fruits rouges Marco Polo prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-030",
        name: "Thé Lapsang Souchong fumé 100g prestige",
        price: 11500,
        origin: "Chine",
        tag: "Thé",
        description: "Thé noir fumé au bois de pin Lapsang Souchong prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-031",
        name: "Thé Long Jing puits du dragon 100g prestige",
        price: 18500,
        origin: "Chine",
        tag: "Thé",
        description: "Thé vert chinois plat impérial Long Jing prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-032",
        name: "Thé Bai Mu Tan white peony 100g prestige",
        price: 15500,
        origin: "Chine",
        tag: "Thé",
        description: "Thé blanc sec et délicat Bai Mu Tan prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-033",
        name: "Thé Sencha Kagoshima 100g prestige",
        price: 14500,
        origin: "Japon",
        tag: "Thé",
        description: "Thé vert japonais vif Sencha Kagoshima prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-034",
        name: "Thé Matcha cérémonie Uji 50g prestige",
        price: 28000,
        origin: "Japon",
        tag: "Thé",
        description: "Matcha cérémonial Uji de Kyoto prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-035",
        name: "Thé Gyokuro Asahi Shizuoka 50g prestige",
        price: 29000,
        origin: "Japon",
        tag: "Thé",
        description: "Thé vert d'ombre précieux Gyokuro Asahi prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-036",
        name: "Thé Genmaicha premium 100g prestige",
        price: 9500,
        origin: "Japon",
        tag: "Thé",
        description: "Sencha et riz soufflé Genmaicha premium.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-037",
        name: "Pu-erh millésimé 2007 Yunnan 100g prestige",
        price: 18500,
        origin: "Chine",
        tag: "Thé",
        description: "Thé sombre vieilli Yunnan Pu-erh 2007 prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-038",
        name: "Thé Oolong Tie Guan Yin 100g prestige",
        price: 15500,
        origin: "Chine",
        tag: "Thé",
        description: "Oolong léger Reine des Orchidées Tie Guan Yin prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-039",
        name: "Thé Da Hong Pao Wuyi 50g prestige",
        price: 32000,
        origin: "Chine",
        tag: "Thé",
        description: "Oolong Big Red Robe de Wuyi Da Hong Pao prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-040",
        name: "Coffret grands crus Mariage Frères 5 x 50g prestige",
        price: 38500,
        origin: "France",
        tag: "Coffret",
        description: "Coffret 5 grands crus Mariage Frères prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-041",
        name: "Coffret grands crus Dammann Frères 5 x 50g prestige",
        price: 32500,
        origin: "France",
        tag: "Coffret",
        description: "Coffret 5 grands crus Dammann Frères prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-042",
        name: "Théière en fonte japonaise Tetsubin 1L prestige",
        price: 55000,
        origin: "Japon",
        tag: "Ustensile",
        description: "Théière en fonte japonaise Tetsubin 1L prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-043",
        name: "Théière en porcelaine Hermès Mosaique au 24 prestige",
        price: 145000,
        origin: "Paris",
        tag: "Ustensile",
        description: "Théière Hermès Mosaique prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-044",
        name: "Service à thé en porcelaine Raynaud set 4 pièces prestige",
        price: 95000,
        origin: "Limousin",
        tag: "Ustensile",
        description: "Service à thé Raynaud prestige Limousin.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-045",
        name: "Tisane Verveine fine de Provence 50g prestige",
        price: 7500,
        origin: "France",
        tag: "Tisane",
        description: "Verveine citronnelle séchée Provence prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-046",
        name: "Tisane Camomille noble d'Égypte 50g prestige",
        price: 6500,
        origin: "Égypte",
        tag: "Tisane",
        description: "Camomille matricaire noble d'Égypte prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-047",
        name: "Cacao en poudre Valrhona 1kg prestige",
        price: 16500,
        origin: "France",
        tag: "Cacao",
        description: "Poudre pure 100% cacao Valrhona prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-048",
        name: "Tablette Valrhona Manjari 70% 70g prestige",
        price: 5500,
        origin: "France",
        tag: "Chocolat",
        description: "Grand cru Madagascar Valrhona Manjari 70% prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-049",
        name: "Tablette Valrhona Guanaja 70% 70g prestige",
        price: 5500,
        origin: "France",
        tag: "Chocolat",
        description: "Grand cru intense Caraïbes Valrhona Guanaja 70% prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
      {
        id: "comptoir-cafes-050",
        name: "Coffret dégustation grands crus Valrhona 10 tablettes prestige",
        price: 42000,
        origin: "France",
        tag: "Coffret",
        description: "Coffret 10 tablettes grands crus Valrhona prestige.",
        boutiqueId: "comptoir-cafes",
        boutiqueName: "Le Comptoir des Cafés",
      },
    ],
  },
  {
    id: "epicerie-monde",
    name: "Épicerie du Monde",
    subtitle: "Trésors des cinq continents prestige",
    countLabel: "50 produits prestige",
    tagline: "Le voyage en bouche",
    icon: "❂",
    accent: "#c87b4a",
    description: "Trésors des cinq continents : épices rares, riz d'Asie, sauces japonaises, huiles d'Orient, café d'Éthiopie, chocolat mexicain, fruits exotiques, charcuteries italiennes et fromages du monde. Une épicerie qui célèbre la diversité culinaire, du marché de Sénégal aux souks de Marrakech.",
    products: [
      {
        id: "epicerie-monde-001",
        name: "Coffret Découverte Terroir premium Sénégal",
        price: 45000,
        origin: "Sénégal",
        tag: "Coffret",
        description: "Coffret Miel Bissap Café Touba premium Sénégal.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-002",
        name: "Coffret Thé & Dentelle Ataya premium Sénégal",
        price: 38500,
        origin: "Sénégal",
        tag: "Coffret",
        description: "Ataya Menthe Sucre candi premium Sénégal.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-003",
        name: "Coffret Riz & Épices d'Or premium",
        price: 32000,
        origin: "Importé",
        tag: "Coffret",
        description: "Basmati Safran Cardamome premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-004",
        name: "Café Touba Sénégal premium 250g",
        price: 6500,
        origin: "Sénégal",
        tag: "Café",
        description: "Café traditionnel sénégalais épicé Touba premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-005",
        name: "Miel du Sénégal pur fleurs sahéliennes 500g premium",
        price: 9500,
        origin: "Sénégal",
        tag: "Sucré",
        description: "Miel pur du Sénégal fleurs sahéliennes premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-006",
        name: "Poudre de Baobab bio premium 200g",
        price: 8500,
        origin: "Sénégal",
        tag: "Complément",
        description: "Poudre de baobab bio vitamine C premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-007",
        name: "Jus de Bissap bio premium 1L",
        price: 5500,
        origin: "Sénégal",
        tag: "Boisson",
        description: "Jus d'hibiscus bio Bissap premium Sénégal.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-008",
        name: "Safran sargol Iranian premium 2g",
        price: 22000,
        origin: "Iran",
        tag: "Épice",
        description: "Safran sargol pur rouge Iranian premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-009",
        name: "Vanille Bourbon Madagascar premium 10 gousses",
        price: 19500,
        origin: "Madagascar",
        tag: "Épice",
        description: "Vanille planiflore bourbon longue premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-010",
        name: "Vanille Tahitensis Tahiti premium 10 gousses",
        price: 25000,
        origin: "Polynésie",
        tag: "Épice",
        description: "Vanille tahitienne fleurie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-011",
        name: "Cardamome verte du Guatemala premium 50g",
        price: 6500,
        origin: "Guatemala",
        tag: "Épice",
        description: "Cardamome verte grosse calibre Guatemala premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-012",
        name: "Poivre Voatsiperifery Madagascar premium 50g",
        price: 9500,
        origin: "Madagascar",
        tag: "Épice",
        description: "Poivre sauvage arborescent Voatsiperifery premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-013",
        name: "Poivre de Timut Népal premium 50g",
        price: 7500,
        origin: "Népal",
        tag: "Épice",
        description: "Poivre agrume pamplemousse Timut premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-014",
        name: "Poivre de Sichuan séché premium 50g",
        price: 6500,
        origin: "Chine",
        tag: "Épice",
        description: "Baie de Sichuan citronnée premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-015",
        name: "Poivre Sansho japonais premium 50g",
        price: 9500,
        origin: "Japon",
        tag: "Épice",
        description: "Poivre japonais citronné Sansho premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-016",
        name: "Sumac séché Iran premium 100g",
        price: 4500,
        origin: "Iran",
        tag: "Épice",
        description: "Sumac pour cuisine persane premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-017",
        name: "Za'atar mélange libanais premium 100g",
        price: 4800,
        origin: "Liban",
        tag: "Épice",
        description: "Thym sésame sumac Za'atar libanais premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-018",
        name: "Ras-el-Hanout 27 épices premium 100g",
        price: 5500,
        origin: "Maroc",
        tag: "Épice",
        description: "27 épices mélange traditionnel Ras-el-Hanout premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-019",
        name: "Berbéré éthiopien premium 100g",
        price: 5200,
        origin: "Éthiopie",
        tag: "Épice",
        description: "Mélange pour wat éthiopien Berbéré premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-020",
        name: "Garam Masala Inde premium 100g",
        price: 4800,
        origin: "Inde",
        tag: "Épice",
        description: "Mélange indien doux Garam Masala premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-021",
        name: "Curry de Madras premium 100g",
        price: 4200,
        origin: "Inde",
        tag: "Épice",
        description: "Curry sud-indien jaune Madras premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-022",
        name: "Curry rouge thaï premium 100g",
        price: 4800,
        origin: "Thaïlande",
        tag: "Épice",
        description: "Pâte curry rouge piment thaï premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-023",
        name: "Curry vert thaï premium 100g",
        price: 4800,
        origin: "Thaïlande",
        tag: "Épice",
        description: "Pâte curry vert citronnelle thaï premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-024",
        name: "Massaman curry premium 100g",
        price: 5200,
        origin: "Thaïlande",
        tag: "Épice",
        description: "Curry massaman doux thaï premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-025",
        name: "Gingembre confit Australie premium 200g",
        price: 4800,
        origin: "Australie",
        tag: "Confiserie",
        description: "Gingembre cristallisé tendre Australie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-026",
        name: "Wasabi en poudre Japon Shizuoka premium 50g",
        price: 9500,
        origin: "Japon",
        tag: "Épice",
        description: "Wasabi pur japonais Shizuoka premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-027",
        name: "Pâte de wasabi tube premium 43g",
        price: 5200,
        origin: "Japon",
        tag: "Épice",
        description: "Pâte wasabi authenticité premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-028",
        name: "Mirin Honteri premium 300ml",
        price: 6500,
        origin: "Japon",
        tag: "Épicerie",
        description: "Vin de riz doux cuisine Mirin Honteri premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-029",
        name: "Sauce soja Kikkoman premium 250ml",
        price: 3500,
        origin: "Japon",
        tag: "Épicerie",
        description: "Sauce soja naturellement fermentée Kikkoman premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-030",
        name: "Sauce soja tamari sans gluten premium 250ml",
        price: 4200,
        origin: "Japon",
        tag: "Épicerie",
        description: "Sauce soja sans gluten tamari premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-031",
        name: "Vinaigre de riz japonais premium 250ml",
        price: 4500,
        origin: "Japon",
        tag: "Épicerie",
        description: "Vinaigre doux sushis japonais premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-032",
        name: "Huile de sésame torréfiée premium 250ml",
        price: 4800,
        origin: "Japon",
        tag: "Huile",
        description: "Huile sésame foncée saveur intense premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-033",
        name: "Riz japonica Koshihikari Niigata 1kg premium",
        price: 9500,
        origin: "Japon",
        tag: "Épicerie",
        description: "Riz premium Koshihikari Niigata Japon premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-034",
        name: "Riz basmati vieilli Inde 1kg premium",
        price: 5500,
        origin: "Inde",
        tag: "Épicerie",
        description: "Basmati 12 mois agee premium Inde.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-035",
        name: "Riz carnaroli Acquerello Italie 1kg premium",
        price: 9500,
        origin: "Italie",
        tag: "Épicerie",
        description: "Riz risotto Acquerello carnaroli premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-036",
        name: "Pâtes artisanales Senatore Cappelli premium 500g",
        price: 4500,
        origin: "Italie",
        tag: "Épicerie",
        description: "Pâtes anciennes blé dur Italie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-037",
        name: "Mozzarella di bufala campana AOP 250g premium",
        price: 4500,
        origin: "Italie",
        tag: "Frais",
        description: "Mozzarella bufflonne AOP Campanie Italie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-038",
        name: "Burrata des Pouilles Andria premium 250g",
        price: 4500,
        origin: "Italie",
        tag: "Frais",
        description: "Burrata Andria fraîche Pouilles Italie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-039",
        name: "Parmigiano Reggiano 36 mois premium 250g",
        price: 6500,
        origin: "Italie",
        tag: "Fromage",
        description: "Parmesan affiné 36 mois Parmigiano Reggiano premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-040",
        name: "Prosciutto di Parma 24 mois DOP premium 200g",
        price: 8500,
        origin: "Italie",
        tag: "Charcuterie",
        description: "Jambon cru de Parme DOP Prosciutto di Parma premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-041",
        name: "Coppa di Parma DOP premium 200g",
        price: 6500,
        origin: "Italie",
        tag: "Charcuterie",
        description: "Coppa du cou DOP Coppa di Parma Italie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-042",
        name: "Olive taggiasche IGP Ligurie premium 200g",
        price: 3800,
        origin: "Italie",
        tag: "Apéritif",
        description: "Olive taggiasche Ligurie IGP Italie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-043",
        name: "Dattes Medjool Jordanie premium 500g",
        price: 7500,
        origin: "Jordanie",
        tag: "Frais",
        description: "Dattes Medjool premium Jordanie premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-044",
        name: "Miel de manuka UMF 20+ Nouvelle-Zélande premium 250g",
        price: 28000,
        origin: "Nouvelle-Zélande",
        tag: "Sucré",
        description: "Miel de manuka UMF 20+ premium antibactérien.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-045",
        name: "Huile d'olive vierge extra Toscane IGP 75cl premium",
        price: 12500,
        origin: "Italie",
        tag: "Huile",
        description: "Huile d'olive Toscane IGP premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-046",
        name: "Vinaigre balsamique de Modène 25 ans premium 25cl",
        price: 32000,
        origin: "Italie",
        tag: "Condiment",
        description: "Vinaigre balsamique traditionnel de Modène IGP premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-047",
        name: "Pesto alla Genovese DOP premium 190g",
        price: 5500,
        origin: "Italie",
        tag: "Apéritif",
        description: "Pesto basilic Genovese DOP premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-048",
        name: "Caviar d'Aquitaine Baeri Premium 50g prestige",
        price: 45000,
        origin: "Gironde",
        tag: "Caviar",
        description: "Caviar d'esturgeon baeri fermier d'Aquitaine premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-049",
        name: "Truffe noire mélanosporum bocal 25g premium",
        price: 65000,
        origin: "Dordogne",
        tag: "Condiment",
        description: "Truffe noire du Périgord en bocal premium.",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
      {
        id: "epicerie-monde-050",
        name: "Coffret trésors du monde premium : safran, vanille, sauge",
        price: 45000,
        origin: "Importé",
        tag: "Coffret",
        description: "Coffret premium safran sargol, vanille Bourbon, sauge",
        boutiqueId: "epicerie-monde",
        boutiqueName: "Épicerie du Monde",
      },
    ],
  },
  {
    id: "espace-enfant",
    name: "L'Espace Enfant",
    subtitle: "Puériculture & Jouets Premium",
    countLabel: "50 produits prestige",
    tagline: "L'enfance préservée",
    icon: "❉",
    accent: "#a87c5d",
    description: "Puériculture, jouets et vêtements pour enfants de 0 à 12 ans. Marques de confiance premium : Bugaboo, Cybex, Stokke, Steiff, LEGO, Janod, Vilac. Poussettes, sièges-auto, jeux d'éveil en bois, peluches Steiff et vêtements bio. L'enfance accompagnée avec exigence et douceur.",
    products: [
      {
        id: "espace-enfant-001",
        name: "Poussette Bugaboo Fox 5 Mono premium",
        price: 525000,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Poussette tout-terrain légère Bugaboo Fox 5 premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-002",
        name: "Poussette Bugaboo Donkey 5 Mono premium",
        price: 625000,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Poussette duo modulable Bugaboo Donkey 5 premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-003",
        name: "Poussette Bugaboo Bee 6 premium",
        price: 385000,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Poussette citadine Bugaboo Bee 6 premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-004",
        name: "Poussette Cybex Priam Lux premium",
        price: 425000,
        origin: "Allemagne",
        tag: "Puériculture",
        description: "Poussette 3-en-1 élégante Cybex Priam Lux premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-005",
        name: "Poussette Cybex Balios S Lux premium",
        price: 365000,
        origin: "Allemagne",
        tag: "Puériculture",
        description: "Poussette Cybex Balios S Lux premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-006",
        name: "Poussette Stokke Xplory X premium",
        price: 495000,
        origin: "Norvège",
        tag: "Puériculture",
        description: "Poussette haute parent-enfant Stokke Xplory X premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-007",
        name: "Poussette Stokke Beat premium",
        price: 425000,
        origin: "Norvège",
        tag: "Puériculture",
        description: "Poussette citadine Stokke Beat premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-008",
        name: "Siège-auto Cybex Sirona T i-Size premium",
        price: 185000,
        origin: "Allemagne",
        tag: "Puériculture",
        description: "Siège pivotant 360° sécurité Cybex Sirona premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-009",
        name: "Siège-auto Maxi-Cosi Pearl 360 Pro premium",
        price: 185000,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Rotation SlideTech Maxi-Cosi Pearl 360 premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-010",
        name: "Siège-auto Britax Römer Advansafix premium",
        price: 165000,
        origin: "Allemagne",
        tag: "Puériculture",
        description: "Siège 9 mois à 12 ans Britax Römer Advansafix premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-011",
        name: "Couffin Natix en osier natural premium",
        price: 75000,
        origin: "France",
        tag: "Puériculture",
        description: "Couffin traditionnel osier Natix France premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-012",
        name: "Berceau Babybjörn Sleep premium",
        price: 105000,
        origin: "Suède",
        tag: "Puériculture",
        description: "Berceau basculant naturel Babybjörn Sleep premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-013",
        name: "Lit à barreaux enfant Leander premium",
        price: 285000,
        origin: "Danemark",
        tag: "Puériculture",
        description: "Lit évolutif 5 dimensions Leander premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-014",
        name: "Lit Montessori au sol 70x140 premium",
        price: 125000,
        origin: "France",
        tag: "Puériculture",
        description: "Lit bas Montessori pin massif France premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-015",
        name: "Commode à langer Combelle pin massif premium",
        price: 165000,
        origin: "France",
        tag: "Puériculture",
        description: "Commode à langer bois naturel Combelle premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-016",
        name: "Chaise haute Stokke Tripp Trapp premium",
        price: 115000,
        origin: "Norvège",
        tag: "Puériculture",
        description: "Chaise évolutive bois hêtre Stokke Tripp Trapp premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-017",
        name: "Chaise haute Peg Perego Prima Pappa premium",
        price: 85000,
        origin: "Italie",
        tag: "Puériculture",
        description: "Chaise haute repliable Peg Perego Prima Pappa premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-018",
        name: "Transat Babybjörn Bouncer Bliss premium",
        price: 85000,
        origin: "Suède",
        tag: "Puériculture",
        description: "Transat naturel balancement Babybjörn Bouncer premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-019",
        name: "Porte-bébé Ergobaby Omni 360 premium",
        price: 65000,
        origin: "États-Unis",
        tag: "Puériculture",
        description: "Porte-bébé 4 positions ergonomique Ergobaby premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-020",
        name: "Porte-bébé Babybjörn One Air premium",
        price: 72000,
        origin: "Suède",
        tag: "Puériculture",
        description: "Porte-bébé respirant mesh Babybjörn One Air premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-021",
        name: "Sac à dos Lässig Mini Backpack premium",
        price: 22000,
        origin: "Allemagne",
        tag: "Puériculture",
        description: "Sac à dos maternelle réfléchissant Lässig premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-022",
        name: "Trousse de toilette Béaba 3en1 premium",
        price: 22000,
        origin: "France",
        tag: "Puériculture",
        description: "Trousse naissance complète Béaba 3en1 premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-023",
        name: "Tire-lait Medela Swing Maxi Flex premium",
        price: 125000,
        origin: "Suisse",
        tag: "Puériculture",
        description: "Tire-lait double double-fréquence Medela Swing Maxi premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-024",
        name: "Tire-lait Philips Avent Natural premium",
        price: 85000,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Tire-lait électrique silencieux Philips Avent premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-025",
        name: "Stérilisateur Philips Avent 4en1 premium",
        price: 42000,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Stérilisateur micro-ondes électrique Philips Avent premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-026",
        name: "Biberon Philips Avent Anti-colique 4x260ml premium",
        price: 22000,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Biberons anti-colique lot de 4 Philips Avent premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-027",
        name: "Biberon Dr Brown's Original 4x250ml premium",
        price: 26500,
        origin: "États-Unis",
        tag: "Puériculture",
        description: "Biberon vent system anti-colique Dr Brown's premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-028",
        name: "Tétine MAM Skin Soft silicone 4 pièces premium",
        price: 12500,
        origin: "Autriche",
        tag: "Puériculture",
        description: "Tétines silicone symétrique MAM Skin Soft premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-029",
        name: "Tétine Philips Avent ultra air 4 pièces premium",
        price: 12500,
        origin: "Pays-Bas",
        tag: "Puériculture",
        description: "Tétines ultra-air respirantes Philips Avent premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-030",
        name: "Tapis à langer Lässig waterproof premium",
        price: 18000,
        origin: "Allemagne",
        tag: "Puériculture",
        description: "Tapis à langer imperméable Lässig premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-031",
        name: "Sophie la girafe premium",
        price: 12500,
        origin: "France",
        tag: "Jouet",
        description: "Jouet en caoutchouc naturel Sophie la girafe France premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-032",
        name: "Jouet empilage Grimms arcs-en-ciel premium",
        price: 38500,
        origin: "Allemagne",
        tag: "Jouet",
        description: "Arc-en-ciel bois coloré Grimm Allemagne premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-033",
        name: "Jouet empilage Grimms triangles premium",
        price: 22500,
        origin: "Allemagne",
        tag: "Jouet",
        description: "Triangles bois empilables Grimm Allemagne premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-034",
        name: "Cubes d'activités Hape wooden premium",
        price: 32500,
        origin: "Suisse",
        tag: "Jouet",
        description: "Cubes d'activités en bois Hape Suisse premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-035",
        name: "Puzzle en bois Janod 24 pièces premium",
        price: 12500,
        origin: "France",
        tag: "Jouet",
        description: "Puzzle en bois magnétique Janod France premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-036",
        name: "Puzzle en bois Janod 100 pièces premium",
        price: 16500,
        origin: "France",
        tag: "Jouet",
        description: "Puzzle grand format Janod France premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-037",
        name: "Voiture en bois Vilac collection premium",
        price: 14500,
        origin: "France",
        tag: "Jouet",
        description: "Voiture bois rétro Vilac France premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-038",
        name: "Trottinette Micro Sprite 2 roues premium",
        price: 42500,
        origin: "Suisse",
        tag: "Jouet",
        description: "Trottinette 2 roues pliable Micro Sprite premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-039",
        name: "Trottinette Micro Maxi Deluxe 3 roues premium",
        price: 62500,
        origin: "Suisse",
        tag: "Jouet",
        description: "Trottinette 3 roues 5-12 ans Micro Maxi Deluxe premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-040",
        name: "Tricycle SmarTrike Breeze premium",
        price: 49500,
        origin: "Israël",
        tag: "Jouet",
        description: "Tricycle évolutif 10-36 mois SmarTrike premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-041",
        name: "Draisienne Early Rider Classic premium",
        price: 65000,
        origin: "Royaume-Uni",
        tag: "Jouet",
        description: "Draisienne bois FSC premium Early Rider premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-042",
        name: "Vélo 14 pouces Early Rider Belter premium",
        price: 125000,
        origin: "Royaume-Uni",
        tag: "Jouet",
        description: "Vélo 14 pouces courroie Early Rider Belter premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-043",
        name: "Malette Lego Classic 484 pièces premium",
        price: 14500,
        origin: "Danemark",
        tag: "Jouet",
        description: "Lego Classic boîte à idées Danemark premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-044",
        name: "Lego City Police 602 pièces premium",
        price: 22000,
        origin: "Danemark",
        tag: "Jouet",
        description: "Lego City station de police Danemark premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-045",
        name: "Lego Star Wars Millennium Falcon 1351 pièces premium",
        price: 75000,
        origin: "Danemark",
        tag: "Jouet",
        description: "Lego Star Wars set premium Millennium Falcon premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-046",
        name: "Lego Friends Hôtel Grand 1450 pièces premium",
        price: 55000,
        origin: "Danemark",
        tag: "Jouet",
        description: "Lego Friends hôtel grand Danemark premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-047",
        name: "Poupée Corolle Mon Grand Bébé premium",
        price: 25500,
        origin: "France",
        tag: "Jouet",
        description: "Poupée 42cm Corolle vanilla France premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-048",
        name: "Dinosaure Schleich Tyrannosaure premium",
        price: 16500,
        origin: "Allemagne",
        tag: "Jouet",
        description: "Figurine réaliste Schleich Allemagne premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-049",
        name: "Peluche Steiff ours boutons 35cm premium",
        price: 38500,
        origin: "Allemagne",
        tag: "Jouet",
        description: "Ours Steiff bouton oreille Allemagne premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
      {
        id: "espace-enfant-050",
        name: "Peluche Jellycat Bashful Bunny 31cm premium",
        price: 14500,
        origin: "Royaume-Uni",
        tag: "Jouet",
        description: "Lapin Jellycat Cuddly Royaume-Uni premium.",
        boutiqueId: "espace-enfant",
        boutiqueName: "L'Espace Enfant",
      },
    ],
  },
];

// Flattened list of all 600 products for the master table
export const allProducts: Product[] = boutiques.flatMap((b) => b.products);

// Aggregate stats
export const stats = {
  boutiqueCount: boutiques.length,
  productCount: allProducts.length,
  minPrice: Math.min(...allProducts.map((p) => p.price)),
  maxPrice: Math.max(...allProducts.map((p) => p.price)),
  avgPrice: Math.round((allProducts.reduce((acc, p) => acc + p.price, 0) / allProducts.length) * 100) / 100,
};

export const boutiqueIds = boutiques.map((b) => b.id);

export const allTags = ["Apéritif", "Argenterie", "Aromathérapie", "Audio", "Biscuit", "Boisson", "Boucherie", "Bougie", "Cacao", "Café", "Caviar", "Champagne", "Charcuterie", "Chocolat", "Coffret", "Complément", "Condiment", "Confiserie", "Conserve", "Console", "Crémerie", "Cuisine", "Drone", "Décoration", "Frais", "Fromage", "Huile", "Jouet", "Linge", "Lunetterie", "Maquillage", "Maroquinerie", "Marée", "Montre connectée", "Médical", "Ordinateur", "Pain", "Parfum", "Pharmacie", "Photo", "Porcelaine", "Premiers secours", "Puériculture", "Pâtisserie", "Smartphone", "Soin corps", "Soin visage", "Soin yeux", "Spiritueux", "Stockage", "Sucré", "TV", "Tablette", "Textile", "Thé", "Tisane", "Ustensile", "VR", "Vaisselle", "Verrerie", "Viennoiserie", "Vin blanc", "Vin doux", "Vin rosé", "Vin rouge", "Volaille", "Écran", "Électroménager", "Épice", "Épicerie"];
